(() => {
  'use strict';
  class HospitalPatientChart extends HTMLElement {
    connectedCallback() {
      if (this.__hospitalPatientChartInitialised) return;
      this.__hospitalPatientChartInitialised = true;

"use strict";
var appRoot=this;
var $=function(id){return appRoot.querySelector("#"+id)};
var uiConfig={};
var configNode=appRoot.querySelector('[data-hpc-config]');
if(configNode){try{uiConfig=JSON.parse(configNode.textContent||'{}')}catch(e){uiConfig={};}}
function ui(key,fallback){return Object.prototype.hasOwnProperty.call(uiConfig,key)&&uiConfig[key]!==''?uiConfig[key]:fallback;}


/* ---------- formatting ---------- */
function fmt(x){
  if(typeof x!=="number"||!isFinite(x))return "-";
  if(Math.abs(x)>=1000)return Math.round(x).toLocaleString("en");
  return parseFloat(x.toPrecision(4)).toString();
}
function fmtShort(x){
  if(typeof x!=="number"||!isFinite(x))return "";
  if(Math.abs(x)>=1000)return Math.round(x).toString();
  return parseFloat(x.toPrecision(3)).toString();
}
function pad2(n){return (n<10?"0":"")+n}
function endedWhen(m){return m.endedAt?m.endedAt.slice(0,16).replace("T"," ")+" UTC":""}
function strictDecimal(value){
  var raw=String(value==null?"":value).trim();
  if(!/^(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i.test(raw))return null;
  var n=Number(raw);
  return isFinite(n)?n:null;
}

/* ---------- segmented controls ---------- */
var segState={};
function initSeg(id,def,cb,allowClear){
  var wrap=$(id);
  var pressed=wrap.querySelector('button[aria-pressed="true"]');
  segState[id]=pressed?pressed.getAttribute("data-val"):(def||null);
  Array.prototype.forEach.call(wrap.querySelectorAll("button"),function(btn){
    btn.addEventListener("click",function(){
      var wasPressed=btn.getAttribute("aria-pressed")==="true";
      Array.prototype.forEach.call(wrap.querySelectorAll("button"),function(b){b.setAttribute("aria-pressed","false")});
      if(allowClear&&wasPressed){
        segState[id]=null;
      }else{
        btn.setAttribute("aria-pressed","true");
        segState[id]=btn.getAttribute("data-val");
      }
      notice("","");
      if(cb)cb(segState[id]);
      renderAlerts();
    });
  });
}

/* ---------- alerts ---------- */
var FLAG_EMOJIS={barrier:"🧤",immune:"🛡️",infectious:"☣️",cytotoxic:"🧪",seizure:"⚡",diet:"🍽️",npo:"🚫"};
var BEHAVIOUR_EMOJIS={Calm:"🙂",Anxious:"😟",Aggressive:"⚠️"};
function behaviourDisplay(){var b=segState.segBeh;return (BEHAVIOUR_EMOJIS[b]||"🐾")+" "+(b||"NOT SET")}
function chip(cls,txt,icon){return '<span class="achip '+cls+'">'+(icon?'<span class="chip-emoji" aria-hidden="true">'+icon+'</span>':'')+'<span>'+escapeHtml(txt)+'</span></span>'}
function hasNewNpoFreeText(row){
  var text=($("iNPO").value||"").trim();
  return !!text&&(!row||text!==String(row.npoInstruction||"").trim());
}
function renderAlerts(){
  var out=[];
  var code=segState.segCode;
  if(code==="DNR")out.push(chip("red",ui("alert_dnr","DNR: do not resuscitate")));
  else if(code==="CPR")out.push(chip("green",ui("alert_cpr","CPR: resuscitate")));
  else out.push(chip("amber",ui("alert_code_unset","Code status not set")));
  if(segState.segBarrier==="Gloves")out.push(chip("barrier",ui("alert_barrier_gloves","Barrier: gloves"),FLAG_EMOJIS.barrier));
  else if(segState.segBarrier==="Full PPE")out.push(chip("barrier",ui("alert_barrier_ppe","Barrier: full PPE"),FLAG_EMOJIS.barrier));
  if(segState.segImm==="Yes")out.push(chip("immune",ui("alert_immune","Immunocompromised"),FLAG_EMOJIS.immune));
  if(segState.segInf==="Yes")out.push(chip("infectious",ui("alert_infectious","Infectious: isolate"),FLAG_EMOJIS.infectious));
  if(segState.segInf==="Yes"&&(segState.segBarrier==="None"||!segState.segBarrier))out.push(chip("amber",ui("alert_no_barrier","Infectious but no barrier level set"),FLAG_EMOJIS.barrier));
  if(segState.segChemo==="Yes")out.push(chip("cytotoxic",ui("alert_cytotoxic","Cytotoxic precautions"),FLAG_EMOJIS.cytotoxic));
  if(segState.segSz==="Yes")out.push(chip("seizure",ui("alert_seizure","Seizure watch"),FLAG_EMOJIS.seizure));
  var npoRow=null;
  for(var ni=0;ni<meds.length;ni++)if(meds[ni].type==="npo"){npoRow=meds[ni];break;}
  if(npoRow&&Object.keys(npoRow.cells||{}).length){
    if(npoRow.npoContinued){
      out.push(chip("red",npoRow.npo.end==null?"NPO continuing":("NPO until "+pad2(npoRow.npo.end)+":00"),FLAG_EMOJIS.npo));
    }else{
      out.push(chip("red","NPO from "+pad2(npoRow.npo.start)+":00",FLAG_EMOJIS.npo));
    }
  }
  else if(hasNewNpoFreeText(npoRow))out.push(chip("red","NPO",FLAG_EMOJIS.npo));
  if(segState.segDiet==="Yes"||($('iDietText').value||"").trim())out.push(chip("diet",ui("alert_diet","Special diet"),FLAG_EMOJIS.diet));
  var w=getWeight();
  if(w&&w>90)out.push(chip("amber","Check weight: over 90 kg"));
  $("alertStrip").innerHTML=out.join("");
}

/* ---------- weight ---------- */
var LB_PER_KG=2.20462;
function getWeight(){
  var w=parseFloat($("iWeight").value);
  if(!isFinite(w)||w<=0)return null;
  if(segState.segWU==="lb")w=w/LB_PER_KG;
  return w;
}

var G_PER_OZ=28.3495;
function bothWeights(kg){return fmt(kg)+" kg ("+fmt(kg*LB_PER_KG)+" lb)"}
function renderWConv(){
  var kg=getWeight();
  var box=$("wConv");
  if(!kg){box.textContent="";return;}
  box.textContent=segState.segWU==="lb"?("= "+fmt(kg)+" kg"):("= "+fmt(kg*LB_PER_KG)+" lb");
}

/* ---------- resting energy requirement ---------- */
function renderRER(){
  var box=$("rerBox");
  var w=getWeight();
  if(!w){box.innerHTML='<span class="rworking">'+escapeHtml(ui("rer_empty","Enter the body weight to calculate the Resting Energy Requirement (RER)."))+'</span>';return;}
  var rer=70*Math.pow(w,0.75);
  var html='<b>RER '+fmt(rer)+' kcal/day</b> <span class="rworking">for '+bothWeights(w)+'</span><br><span class="rworking">Working: RER = 70 × '+fmt(w)+'<sup>0.75</sup> kg = '+fmt(rer)+' kcal/day</span>';
  var species=segState.segSpecies||"dog";
  var dx=segState.segDesexed;
  if(dx==="Yes"||dx==="No"){
    var mult=species==="cat"?(dx==="Yes"?1.2:1.4):(dx==="Yes"?1.6:1.8);
    var mer=mult*rer;
    html+='<br><span class="rworking">Estimated MER: '+mult+' × RER = '+fmt(mer)+' kcal/day ('+(dx==="Yes"?"desexed":"entire")+' '+species+')</span>';
  }
  var kcal=parseFloat($("iDietKcal").value);
  var funit=$("iDietUnit").value;
  var meals=parseInt($("iMeals").value,10)||4;
  if(isFinite(kcal)&&kcal>0){
    var perDay=rer/kcal;
    var feedTxt;
    if(funit==="100g")feedTxt=fmt(perDay*100)+" g ("+fmt(perDay*100/G_PER_OZ)+" oz)/day = "+meals+" meals of "+fmt(perDay*100/meals)+" g ("+fmt(perDay*100/meals/G_PER_OZ)+" oz)";
    else feedTxt=fmt(perDay)+" "+funit+(perDay>=1.05?"s":"")+"/day = "+meals+" meals of "+fmt(perDay/meals)+" "+funit;
    html+='<br><span class="rworking">Feeding at 1 × RER ('+fmt(kcal)+' kcal per '+(funit==="100g"?"100 g":funit)+'): <b>'+feedTxt+'</b></span>';
  }
  html+='<br><span class="rworking">Hospitalised patients are usually started at 1 × RER, split into several small meals, then adjusted to the patient.</span>';
  box.innerHTML=html;
}

/* ---------- medications ---------- */
var meds=[];
var medSeq=0;
var FREQ={
  q24:{label:"SID (q24h)",int:24},
  q12:{label:"BID (q12h)",int:12},
  q8:{label:"TID (q8h)",int:8},
  q6:{label:"QID (q6h)",int:6},
  q4:{label:"q4h",int:4},
  q3:{label:"q3h",int:3},
  q2:{label:"q2h",int:2},
  q1:{label:"q1h",int:1},
  once:{label:"Once",int:0},
  cri:{label:"CRI (continuous)",int:-1},
  prn:{label:"PRN (no set times)",int:-2}
};

function stopHour(id){
  var raw=$(id).value;
  if(raw==="noend"||raw==="")return null;
  var n=Number(raw);
  return Number.isInteger(n)&&n>=0&&n<24?n:null;
}
function stopPhrase(stop){return stop==null?"until further notice":"until "+pad2(stop)+":00"}
function scheduleCells(freq,first,fullCycle,stop){
  var cells={};
  var f=FREQ[freq];
  if(!f)return cells;
  first=parseInt(first,10);
  if(!isFinite(first)||first<0||first>23)first=0;
  if(f.int===-1){
    var from=fullCycle?0:first;
    var until=24;
    if(stop!=null){
      stop=parseInt(stop,10);
      if(isFinite(stop)&&stop>=0&&stop<24){
        if(fullCycle)until=stop<=first?stop:0;
        else if(stop>first)until=stop;
      }
    }
    for(var h=from;h<until;h++)cells[h]=1;
  }
  else if(f.int===-2){/* PRN: nothing pre-marked */}
  else if(f.int===0){cells[first%24]=1;}
  else if(!fullCycle){
    /* On the first chart day, never wrap into hours before the stated first dose. */
    for(var due=first;due<24;due+=f.int)cells[due]=1;
  }
  else{
    /* On following days the order is already established, so render its full anchored cycle. */
    var n=Math.floor(24/f.int);
    for(var k=0;k<n;k++)cells[(first+k*f.int)%24]=1;
  }
  return cells;
}
function reschedulePreservingGiven(m,freq,first,stop){
  var oldCells=m.cells||{};
  var next=scheduleCells(freq,first,false,stop);
  Object.keys(oldCells).forEach(function(h){if(oldCells[h]===2)next[h]=2;});
  m.freq=freq;
  m.first=first;
  m.stop=stop==null?null:stop;
  delete m.stopReached;
  delete m.orderEnded;
  m.cells=next;
  m.continued=false;
}

function doseParts(m){
  var w=getWeight();
  var mg=null,ml=null,u=m.unit||"mgkg";
  if(m.rate!=null){
    if(u==="mgkg"){if(w)mg=m.rate*w;}
    else if(u==="mcgkg"){if(w)mg=m.rate*w/1000;}
    else if(u==="mg"){mg=m.rate;}
    else if(u==="ml"){ml=m.rate;if(m.conc!=null&&m.conc>0)mg=m.rate*m.conc;}
    if(u!=="ml"&&mg!=null&&m.conc!=null&&m.conc>0)ml=mg/m.conc;
  }
  return {mg:mg,ml:ml};
}
function unitLabel(u){return u==="mgkg"?"mg/kg":u==="mcgkg"?"mcg/kg":u==="mg"?"mg":"ml"}

/* ---------- tablet fractions ---------- */
function fracText(q){
  var whole=Math.floor(q+1e-9);
  var rem=Math.round((q-whole)*4)/4;
  if(rem>=1){whole+=1;rem=0;}
  var f=rem===0.25?"1/4":rem===0.5?"1/2":rem===0.75?"3/4":"";
  if(!f)return String(whole);
  return whole===0?f:whole+" "+f;
}
function tabletInfo(m,mg){
  /* A rounded fraction is actionable only when it is at least 1/4 tablet and within 10%. */
  if(!(m.tab>0)||mg==null)return null;
  var exact=mg/m.tab;
  var qr=Math.round(exact*4)/4;
  var given=qr*m.tab;
  var off=mg>0?Math.abs(given-mg)/mg:0;
  var tooSmall=exact<0.25;
  return {qr:qr,given:given,exact:exact,off:off,tooSmall:tooSmall,acceptable:!tooSmall&&qr>0&&off<=0.1};
}
function tabletText(m,mg){
  var t=tabletInfo(m,mg);
  if(!t)return "";
  if(t.tooSmall)return ' <span style="color:var(--red);font-weight:700">= '+fmt(t.exact)+' of a '+fmt(m.tab)+' mg tablet, less than the practical 1/4-tablet minimum: use a smaller strength or a liquid form</span>';
  if(!t.acceptable){
    return ' <span style="color:var(--red);font-weight:700">= '+fmt(t.exact)+' of a '+fmt(m.tab)+' mg tablet; the nearest quarter ('+fracText(t.qr)+') would give '+fmt(t.given)+' mg, '+fmt(t.off*100)+'% away from the calculated dose. No rounded tablet instruction is authorised; choose another strength or formulation.</span>';
  }
  var s=" = <b>"+fracText(t.qr)+" tablet"+(t.qr>1?"s":"")+"</b> of "+fmt(m.tab)+" mg";
  if(Math.abs(t.qr-t.exact)>1e-9){
    s+=" (gives "+fmt(t.given)+" mg";
    s+=")";
  }
  return s;
}

/* ---------- CRI (syringe driver) maths ---------- */
var CRI_UNITS={mcgkgmin:"mcg/kg/min",mcgkghr:"mcg/kg/hr",mgkghr:"mg/kg/hr",mgkgday:"mg/kg/day"};
function criMgPerHr(rate,unit,w){
  if(unit==="mcgkgmin")return rate*60*w/1000;
  if(unit==="mcgkghr")return rate*w/1000;
  if(unit==="mgkghr")return rate*w;
  return rate*w/24; /* mgkgday */
}
function criLine(m){
  var w=getWeight();
  if(!w)return '<span style="color:var(--red);font-weight:700">'+fmt(m.cri.rate)+' '+CRI_UNITS[m.cri.unit]+': enter body weight to calculate</span>';
  var mgHr=criMgPerHr(m.cri.rate,m.cri.unit,w);
  var mlHr=mgHr/m.cri.conc;
  return fmt(m.cri.rate)+" "+CRI_UNITS[m.cri.unit]+" × "+fmt(w)+" kg = "+fmt(mgHr)+" mg/hr = <b>"+fmt(mlHr)+" ml/hr</b> ("+fmt(m.cri.conc)+" mg/ml)";
}
function doseLine(m){
  var w=getWeight();
  var u=m.unit||"mgkg";
  if(m.type==="obs")return '<span style="color:var(--muted)">record values in the cells</span>';
  if(m.type==="npo")return '<span style="color:var(--red);font-weight:700"><span class="inline-emoji" aria-hidden="true">🚫</span> Nothing by mouth</span>';
  if(m.oxy)return oxyLine(m);
  if(m.cri)return criLine(m);
  if(m.rate!=null){
    var perKg=(u==="mgkg"||u==="mcgkg");
    if(perKg&&!w)return '<span style="color:var(--red);font-weight:700">'+fmt(m.rate)+' '+unitLabel(u)+': enter body weight to calculate</span>';
    var d=doseParts(m);
    var s;
    if(u==="mgkg")s=fmt(m.rate)+" mg/kg × "+fmt(w)+" kg = <b>"+fmt(d.mg)+" mg</b>";
    else if(u==="mcgkg")s=fmt(m.rate)+" mcg/kg × "+fmt(w)+" kg = "+fmt(m.rate*w)+" mcg = <b>"+fmt(d.mg)+" mg</b>";
    else if(u==="mg")s="<b>"+fmt(d.mg)+" mg</b> total";
    else s="<b>"+fmt(m.rate)+" ml</b> total"+(d.mg!=null?" = "+fmt(d.mg)+" mg ("+fmt(m.conc)+" mg/ml)":"");
    if(u!=="ml"&&d.ml!=null)s+=" = <b>"+fmt(d.ml)+" ml</b> ("+fmt(m.conc)+" mg/ml)";
    if(u!=="ml")s+=tabletText(m,d.mg);
    return s;
  }
  if(m.manual)return "<b>"+escapeHtml(m.manual)+"</b>";
  return '<span style="color:var(--muted)">dose not set</span>';
}
function cellDose(m){
  if(m.cellText)return escapeHtml(m.cellText);
  var d=doseParts(m);
  if(m.tab>0&&d.mg!=null&&(m.unit||"mgkg")!=="ml"){
    var t=tabletInfo(m,d.mg);
    if(t&&t.acceptable)return fracText(t.qr)+"tab";
  }
  if(d.ml!=null)return fmtShort(d.ml)+"ml";
  if(d.mg!=null)return fmtShort(d.mg)+"mg";
  if(m.manual&&m.manual.length<=8)return escapeHtml(m.manual);
  return "";
}
function escapeHtml(s){return String(s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;")}

function currentHours(){
  /* the chart always runs midnight to midnight */
  var hrs=[];for(var i=0;i<24;i++)hrs.push(i);
  return hrs;
}

function renderHead(){
  var hrs=currentHours();
  var html='<th class="medcol" scope="col">Medication / dose / frequency</th>';
  for(var i=0;i<hrs.length;i++)html+='<th scope="col">'+pad2(hrs[i])+'</th>';
  html+='<th class="rmhead" scope="col" aria-label="Remove"></th>';
  $("medHead").innerHTML=html;
  var nowH=new Date().getHours();
  var ths=$("medHead").children;
  for(var j=0;j<hrs.length;j++){if(hrs[j]===nowH)ths[j+1].classList.add("now");}
}

function renderBody(){
  /* commit any observation value still being typed before the table is rebuilt,
     otherwise a weight or start-hour change would silently discard it */
  var ae=document.activeElement;
  if(ae&&ae.classList&&ae.classList.contains("cellinput"))ae.blur();
  var hrs=currentHours();
  var body=$("medBody");
  body.innerHTML="";
  /* two labelled sections: vitals and care tasks on top, medications and IV fluids below */
  var careRows=meds.filter(function(m){return m.type==="npo"})
    .concat(meds.filter(function(m){return m.type==="obs"}));
  var medRows2=meds.filter(function(m){return m.type!=="obs"&&m.type!=="npo"});
  function secHeader(label){
    var tr=document.createElement("tr");
    tr.className="secrow";
    var td=document.createElement("td");
    td.colSpan=26;
    td.textContent=label;
    tr.appendChild(td);
    body.appendChild(tr);
  }
  if(careRows.length)secHeader(ui("chart_care_section","Vitals and care tasks"));
  var renderRow=function(m){
    var tr=document.createElement("tr");
    tr.className="datarow";
    var info=document.createElement("td");
    info.className="medcell";
    var meta;
    if(m.orderEnded){
      if((m.freq==="cri"||m.ngCri)&&!m.endedAt)meta="Continuous order ended at its scheduled stop";
      else meta=(m.type==="obs"?"Task discontinued":m.type==="npo"?"NPO order ended":"Order discontinued")+(endedWhen(m)?" · "+endedWhen(m):"");
    }else if(m.type==="npo"){
      meta=npoMeta(m);
    }else if(m.freq==="cri"||m.ngCri){
      if(m.orderEnded)meta="Continuous order ended";
      else meta=(m.continued?"Continuous infusion continued from previous day":"Continuous infusion from "+pad2(m.first||0)+":00")+", "+stopPhrase(m.stop);
    }else{
      meta=FREQ[m.freq].label;
      if(m.prn&&m.freq!=="prn")meta+=" PRN (give only if needed)";
      if(FREQ[m.freq].int>0||FREQ[m.freq].int===0)meta+=", first dose "+pad2(m.first)+":00";
      if(m.prevGiven)meta+=" (given on a previous day)";
    }
    var recordedLine=givenSummary(m);
    var drugNameHtml=(m.type==="npo"?'<span class="inline-emoji" aria-hidden="true">🚫</span> ':'')+escapeHtml(m.drug);
    info.innerHTML='<div class="dname"'+(m.type==="npo"?' style="color:var(--red)"':'')+'>'+drugNameHtml+' <span style="color:var(--teal-dark);font-weight:700">'+escapeHtml(m.route)+'</span>'+(m.prn?' <span class="prnbadge">PRN</span>':'')+'</div>'+
      '<div class="dline">'+doseLine(m)+'</div>'+
      '<div class="dmeta">'+escapeHtml(meta)+'</div>'+
      (recordedLine?'<div class="drecord">Recorded: '+escapeHtml(recordedLine)+'</div>':'');
    tr.appendChild(info);
    hrs.forEach(function(h){
      var td=document.createElement("td");
      td.className="hcell"+(m.type==="obs"?" obscell":"");
      paintCell(td,m,h);
      if(m.type!=="npo"&&!m.orderEnded){
        td.tabIndex=0;
        td.setAttribute("role","button");
        var act=m.type==="obs"?function(){editObsCell(m,h,td)}:function(){cycleCell(m,h,td)};
        td.addEventListener("click",function(e){if(e.detail>1)return;act()});
        td.addEventListener("keydown",function(e){if(e.key==="Enter"||e.key===" "){if(e.target!==td)return;e.preventDefault();act()}});
      }
      tr.appendChild(td);
    });
    var rm=document.createElement("td");
    rm.className="rmcell";
    var rb=document.createElement("button");
    rb.className="rmbtn";rb.type="button";
    rb.innerHTML="×";
    rb.setAttribute("aria-label","Remove or discontinue "+m.drug);
    rb.addEventListener("click",function(e){
      if(e.detail>1)return;
      var hasRecord=(m.given&&Object.keys(m.given).length)||(m.givenDetails&&Object.keys(m.givenDetails).length)||(m.vals&&Object.keys(m.vals).length)||(m.audit&&m.audit.length)||(m.history&&m.history.length)||(m.npoHistory&&m.npoHistory.length)||(m.type==="npo"&&!!m.npo)||Object.keys(m.cells||{}).some(function(h){return m.cells[h]===2;});
      if(hasRecord){
        if(m.orderEnded){notice("red","<b>Cannot remove "+escapeHtml(m.drug)+".</b> This discontinued row contains clinical records or an audit trail and must remain in the chart file.");return;}
        if(!window.confirm("This row contains clinical records. Discontinue it now, clear its remaining due cells, and retain all records and audit history?"))return;
        backfillGivenSnapshots(m);
        m.audit=m.audit||[];
        m.endedAt=new Date().toISOString();
        m.audit.push({action:"order_discontinued",endedAt:m.endedAt,chartDate:$("iDate").value||null});
        m.orderEnded=true;m.continued=false;
        if(m.type==="npo")m.npoDone=true;
        var kept={};Object.keys(m.cells||{}).forEach(function(h){if(m.cells[h]===2)kept[h]=2;});m.cells=kept;
        notice("info","<b>Discontinued.</b> "+escapeHtml(m.drug)+" has no remaining due cells. Its administrations, observations and audit history remain in the chart file.");
        renderBody();renderAlerts();return;
      }
      if(!window.confirm("Remove this unrecorded order or task from the chart? This cannot be undone."))return;
      meds=meds.filter(function(x){return x.id!==m.id});
      notice("info","<b>Removed.</b> The unrecorded "+escapeHtml(m.drug)+" row was removed from the chart.");
      renderBody();
      renderAlerts();
    });
    rm.appendChild(rb);
    tr.appendChild(rm);
    body.appendChild(tr);
  };
  careRows.forEach(renderRow);
  if(medRows2.length)secHeader(ui("chart_med_section","Medications and IV fluids"));
  medRows2.forEach(renderRow);
  /* print-only OTHER section: 5 blank rows for handwritten additions at the cage */
  var oh=document.createElement("tr");
  oh.className="secrow otherrow";
  var ohd=document.createElement("td");
  ohd.colSpan=26;
  ohd.textContent=ui("chart_other_section","Other: additional medications and treatments (write in, dose, route and times)");
  oh.appendChild(ohd);
  body.appendChild(oh);
  for(var oi=0;oi<5;oi++){
    var otr=document.createElement("tr");
    otr.className="otherrow";
    var omc=document.createElement("td");
    omc.className="medcell";
    omc.innerHTML="&nbsp;";
    otr.appendChild(omc);
    for(var oj=0;oj<24;oj++){
      var otd=document.createElement("td");
      otd.className="hcell";
      otr.appendChild(otd);
    }
    var orc=document.createElement("td");
    orc.className="rmcell";
    otr.appendChild(orc);
    body.appendChild(otr);
  }
  $("emptyMeds").style.display=meds.length?"none":"block";
  checkFluidSync();
}

function paintCell(td,m,h){
  if(m.type==="obs"){paintObsCell(td,m,h);return;}
  if(m.type==="npo"){paintNpoCell(td,m,h);return;}
  var st=m.cells[h]||0;
  td.classList.toggle("due",st===1);
  td.classList.toggle("given",st===2);
  td.classList.toggle("prncell",st===1&&!!m.prn);
  var stateWord=st===2?"given":(st===1?(m.prn?"due PRN, give only if needed":"due"):"blank");
  td.setAttribute("aria-label",m.drug+" at "+pad2(h)+":00, "+stateWord);
  if(st===1){var cd=cellDose(m);td.innerHTML=cd?'<span class="cdose">'+cd+'</span>':'<span class="cdose duetxt">due</span>';}
  else if(st===2){
    var detail=m.givenDetails&&m.givenDetails[h]?m.givenDetails[h]:null;
    var t=detail&&detail.time?detail.time:((m.given&&m.given[h])?m.given[h]:null);
    td.innerHTML="✓"+(t?'<span class="cdose">'+escapeHtml(t)+'</span>':"");
    if(t)td.setAttribute("aria-label",m.drug+" at "+pad2(h)+":00, given at "+t+(detail&&detail.dose?", "+detail.dose:""));
  }
  else td.innerHTML="";
}
function paintObsCell(td,m,h){
  var v=(m.vals&&m.vals[h]!=null)?m.vals[h]:null;
  var due=(m.cells[h]||0)>=1;
  td.classList.toggle("val",v!=null);
  td.classList.toggle("due",v==null&&due);
  td.classList.remove("given");
  var stateWord=v!=null?("recorded "+v):(due?"due":"blank");
  td.setAttribute("aria-label",m.drug+" at "+pad2(h)+":00, "+stateWord+". Press Enter to type a value.");
  if(v!=null)td.innerHTML='<span class="cdose">'+escapeHtml(v)+'</span>';
  else if(due)td.innerHTML='<span class="cdose duetxt">due</span>';
  else td.innerHTML="";
}
function editObsCell(m,h,td){
  if(td.querySelector("input"))return;
  var cur=(m.vals&&m.vals[h]!=null)?m.vals[h]:"";
  var onceOnly=m.freq==="once";
  if(onceOnly&&m.prevGiven&&!cur){notice("red","<b>Cannot add another value.</b> "+escapeHtml(m.drug)+" is a once-only task already recorded on a previous day.");return;}
  td.innerHTML="";
  var inp=document.createElement("input");
  inp.className="cellinput";
  inp.value=cur;
  inp.setAttribute("aria-label","Value for "+m.drug+" at "+pad2(h)+":00");
  var done=false;
  function commit(refocus){
    if(done)return;done=true;
    var v=inp.value.trim();
    if(cur&& !v&&!window.confirm("Remove the recorded value for "+m.drug+" at "+pad2(h)+":00?")){
      paintObsCell(td,m,h);
      if(refocus)td.focus();
      return;
    }
    if(!m.vals)m.vals={};
    if(v){
      if(onceOnly&&Object.keys(m.vals).some(function(key){return Number(key)!==Number(h)&&m.vals[key]!=null;})){
        notice("red","<b>Cannot add another value.</b> "+escapeHtml(m.drug)+" is a once-only task and already has a recorded result.");
        paintObsCell(td,m,h);
        if(refocus)td.focus();
        return;
      }
      if(cur&&v!==cur){
        m.audit=m.audit||[];
        m.audit.push({action:"observation_changed",hour:h,previous:cur,value:v,changedAt:new Date().toISOString()});
      }
      m.vals[h]=v;
      if(onceOnly){
        Object.keys(m.cells||{}).forEach(function(key){if(Number(key)!==Number(h))delete m.cells[key];});
        m.cells[h]=1;
      }
    }
    else{
      if(cur){
        m.audit=m.audit||[];
        m.audit.push({action:"observation_removed",hour:h,value:cur,removedAt:new Date().toISOString()});
      }
      delete m.vals[h];
      if(onceOnly&&!Object.keys(m.vals).length){m.cells={};if(!m.prevGiven)m.cells[m.first]=1;}
    }
    if(onceOnly)renderBody();else{
      paintObsCell(td,m,h);
      if(refocus)td.focus();
    }
  }
  inp.addEventListener("blur",function(){commit(false)});
  inp.addEventListener("keydown",function(e){
    e.stopPropagation();
    if(e.key==="Enter"){e.preventDefault();commit(true);}
    else if(e.key==="Escape"){done=true;paintObsCell(td,m,h);td.focus();}
  });
  td.appendChild(inp);
  inp.focus();inp.select();
}
function snapshotDoseText(m){
  if(m.isFluid)return m.drug+" at "+(m.manual||"rate not set");
  if(m.oxy)return oxyText(m);
  if(m.cri){
    var cw=getWeight();
    if(!cw)return "weight required";
    return fmt(criMgPerHr(m.cri.rate,m.cri.unit,cw)/m.cri.conc)+" ml/hr ("+fmt(m.cri.rate)+" "+CRI_UNITS[m.cri.unit]+", "+fmt(m.cri.conc)+" mg/ml)";
  }
  if(m.rate==null)return m.manual||"dose not set";
  var d=doseParts(m),u=m.unit||"mgkg",parts=[];
  if(u==="ml"){
    parts.push(fmt(m.rate)+" ml");
    if(d.mg!=null)parts.push(fmt(d.mg)+" mg");
  }else{
    if(d.mg!=null)parts.push(fmt(d.mg)+" mg");
    if(d.ml!=null)parts.push(fmt(d.ml)+" ml");
    if(m.tab>0&&d.mg!=null){
      var ti=tabletInfo(m,d.mg);
      if(ti&&ti.acceptable)parts.push(fracText(ti.qr)+" tablet"+(ti.qr>1?"s":""));
      else if(ti)parts.push("tablet fraction requires review");
    }
  }
  return parts.join(" = ")||"dose not set";
}
function backfillGivenSnapshots(m){
  var given=m.given||{};
  m.givenDetails=m.givenDetails||{};
  Object.keys(given).forEach(function(h){
    if(!m.givenDetails[h])m.givenDetails[h]={time:given[h],recordedAt:"",weightKg:getWeight(),dose:snapshotDoseText(m)};
  });
}
function orderNeedsWeight(m){
  var u=m.unit||"mgkg";
  return !!(m.cri||(m.oxy&&m.oxy.unit==="lkgmin")||(m.rate!=null&&(u==="mgkg"||u==="mcgkg")));
}
function hasUnresolvedTablet(m){
  if(!(m.tab>0))return false;
  var d=doseParts(m),t=tabletInfo(m,d.mg);
  return !!(t&&!t.acceptable);
}
function cycleCell(m,h,td){
  var st=m.cells[h]||0;
  var onceOnly=m.freq==="once"&&m.type!=="npo";
  if(onceOnly){
    if(m.prevGiven){notice("red","<b>Cannot add another dose.</b> "+escapeHtml(m.drug)+" is a once-only order already recorded on a previous day.");return;}
    if(st===0&&Number(h)!==Number(m.first)){
      notice("red","<b>Cannot add another time.</b> "+escapeHtml(m.drug)+" is a once-only order scheduled at "+pad2(m.first)+":00. Record it in that scheduled cell; the actual administration time is captured separately.");
      return;
    }
    var otherGiven=Object.keys(m.given||{}).some(function(key){return Number(key)!==Number(h);})||Object.keys(m.cells||{}).some(function(key){return Number(key)!==Number(h)&&m.cells[key]===2;});
    if(st!==2&&otherGiven){notice("red","<b>Cannot add another dose.</b> "+escapeHtml(m.drug)+" is a once-only order and already has a recorded administration. Remove the existing record first only if correcting an error.");return;}
  }
  if(st===2&&!window.confirm("Remove the recorded administration for "+m.drug+" at "+pad2(h)+":00?"))return;
  var restoreOnceDue=onceOnly&&st===2;
  var next=(st+1)%3;
  if(next===2&&orderNeedsWeight(m)&&!getWeight()){
    notice("red","<b>Cannot record "+escapeHtml(m.drug)+" as given.</b> Restore a valid body weight so the ordered dose or flow can be calculated first.");
    return;
  }
  if(next===2&&m.isFluid&&checkFluidSync()){
    notice("red","<b>Cannot record the fluid check.</b> The charted fluid order is stale or no longer verifiable. Reconcile the calculator and chart row first.");
    return;
  }
  if(next===2&&hasUnresolvedTablet(m)){
    notice("red","<b>Cannot record "+escapeHtml(m.drug)+" as given.</b> The entered tablet strength does not produce an authorised quarter-tablet dose within 10%. Change the strength or formulation, or clear the tablet field after charting an explicit alternative.");
    return;
  }
  st=next;
  if(st===0)delete m.cells[h];else m.cells[h]=st;
  if(st===2){
    if(onceOnly){
      Object.keys(m.cells).forEach(function(key){if(Number(key)!==Number(h)&&m.cells[key]===1)delete m.cells[key];});
    }
    var now=new Date();
    m.given=m.given||{};
    m.given[h]=pad2(now.getHours())+":"+pad2(now.getMinutes());
    m.givenDetails=m.givenDetails||{};
    m.givenDetails[h]={time:m.given[h],recordedAt:now.toISOString(),weightKg:getWeight(),dose:snapshotDoseText(m)};
  }else if(m.given){
    if(m.given[h]){
      m.audit=m.audit||[];
      m.audit.push({action:"administration_removed",hour:h,previous:(m.givenDetails&&m.givenDetails[h])||{time:m.given[h]},removedAt:new Date().toISOString()});
    }
    delete m.given[h];
    if(m.givenDetails)delete m.givenDetails[h];
  }
  if(restoreOnceDue)m.cells[m.first]=1;
  if(onceOnly)renderBody();else paintCell(td,m,h);
}

function notice(cls,msg){
  $("doseNotice").innerHTML=msg?'<div class="warn '+cls+' notice">'+msg+'</div>':"";
}

function addMed(){
  var drug=($("mDrug").value||"").trim();
  if(!drug){notice("amber","<b>Caution.</b> Enter a medication or treatment name before adding it to the chart.");$("mDrug").focus();return;}
  var rateRaw=($("mRate").value||"").trim();
  var concRaw=($("mConc").value||"").trim();
  var tabRaw=($("mTab").value||"").trim();
  var rate=rateRaw===""?NaN:Number(rateRaw);
  var conc=concRaw===""?NaN:Number(concRaw);
  var tab=tabRaw===""?NaN:Number(tabRaw);
  var unit=$("mUnit").value;
  var manual=($("mManual").value||"").trim();
  var freq=$("mFreq").value;
  var first=parseInt($("mFirst").value,10)||0;
  var stop=freq==="cri"?stopHour("mStop"):null;
  if(rateRaw!==""&&["mgkg","mcgkg","mg","ml"].indexOf(unit)===-1){notice("amber","<b>Caution.</b> Choose the dose unit explicitly.");$("mUnit").focus();return;}
  if(rateRaw===""&&["mgkg","mcgkg","mg","ml"].indexOf(unit)===-1)unit="mg";
  if(!$("mRoute").value){notice("amber","<b>Caution.</b> Choose the administration route explicitly.");$("mRoute").focus();return;}
  if(!own(FREQ,freq)){notice("amber","<b>Caution.</b> Choose the frequency explicitly.");$("mFreq").focus();return;}
  if(rateRaw!==""&&!(isFinite(rate)&&rate>0)){notice("amber","<b>Caution.</b> Dose must be a number greater than zero, or left blank when manual dose text is used.");$("mRate").focus();return;}
  if(concRaw!==""&&!(isFinite(conc)&&conc>0)){notice("amber","<b>Caution.</b> Concentration must be a number greater than zero, or left blank.");$("mConc").focus();return;}
  if(tabRaw!==""&&!(isFinite(tab)&&tab>0)){notice("amber","<b>Caution.</b> Tablet strength must be a number greater than zero, or left blank.");$("mTab").focus();return;}
  if(tabRaw!==""&&["PO","NGT","In food"].indexOf($("mRoute").value)===-1){notice("amber","<b>Caution.</b> A tablet strength cannot be paired with the selected parenteral or topical route. Choose an enteral route or clear the tablet field.");$("mRoute").focus();return;}
  if(rateRaw===""&&!manual){notice("amber","<b>Caution.</b> Enter a numeric dose or add clear manual dose instructions before activating this order.");$("mRate").focus();return;}
  if(isFinite(rate)&&(unit==="mgkg"||unit==="mcgkg")&&!getWeight()){
    notice("amber","<b>Caution.</b> Enter the body weight before activating a weight-based order for "+escapeHtml(drug)+".");$("iWeight").focus();return;
  }
  if(freq==="cri"&&isFinite(rate)){
    notice("amber","<b>Caution.</b> The standard dose field is per administration, not per hour. Use the CRI / syringe driver calculator below, or leave the numeric dose blank and enter an explicit manual infusion rate.");return;
  }
  var duplicate=meds.some(function(m){return !m.orderEnded&&m.type!=="obs"&&m.type!=="npo"&&String(m.drug||"").trim().toLowerCase()===drug.toLowerCase()&&String(m.route||"").toLowerCase()===String($("mRoute").value||"").toLowerCase();});
  if(duplicate&&!window.confirm(drug+" is already active on this route. Add a second order anyway?"))return;
  notice("","");
  var m={
    id:++medSeq,
    drug:drug,
    route:$("mRoute").value,
    unit:unit,
    prn:$("mPrn").checked||freq==="prn",
    rate:(isFinite(rate)&&rate>0)?rate:null,
    conc:(isFinite(conc)&&conc>0)?conc:null,
    tab:(isFinite(tab)&&tab>0)?tab:null,
    manual:manual||null,
    freq:freq,
    first:first,
    stop:stop,
    isFluid:false,
    cells:scheduleCells(freq,first,false,stop)
  };
  meds.push(m);
  renderBody();
  $("mDrug").value="";$("mRate").value="";$("mConc").value="";$("mTab").value="";$("mManual").value="";
  $("mUnit").value="";$("mRoute").value="";$("mFreq").value="";$("mStop").value="noend";$("mStop").disabled=true;
  $("mPrn").checked=false;$("prnWrap").classList.remove("on");
  $("mDrug").focus();
}

/* ---------- weight recalculation (rates are stored per row and re-derived, never frozen) ---------- */
var lastWeight=null;
function onWeightChange(){
  var w=getWeight();
  var hasCalc=meds.some(function(m){var u=m.unit||"mgkg";return m.cri||(m.oxy&&m.oxy.unit==="lkgmin")||(m.rate!=null&&(u==="mgkg"||u==="mcgkg"))});
  if(hasCalc&&w&&lastWeight&&Math.abs(w-lastWeight)>0.05){
    notice("info","<b>Note.</b> Body weight changed to "+fmt(w)+" kg. All current weight-based doses and oxygen flows have been recalculated. Recorded administrations retain their original dose and weight snapshots.");
  }else if(hasCalc&&w&&!lastWeight){
    /* replaces the stale "no body weight is entered" caution once the weight arrives */
    notice("info","<b>Note.</b> Body weight set to "+fmt(w)+" kg. All current weight-based doses and oxygen flows have now been calculated. Recheck each order line.");
  }
  lastWeight=w||null;
  renderAlerts();
  renderWConv();
  renderRER();
  renderBody();
  fluidCalc();
  renderCriPreview();
}

/* ---------- fluid type and additives ---------- */
var additives=[];
var addSeq=0;
function fluidLabel(){
  var base=$("fSel").value==="other"?((($("fType").value||"").trim())||"IV fluids"):$("fSel").value;
  var parts=[base];
  additives.forEach(function(a){
    var nm=a.custom?((String(a.name||"").trim())||"additive"):String(a.name||"additive");
    var amt=String(a.amt||"").trim();
    if(amt){
      if(a.unit==="%")parts.push(nm+" "+amt+"%");
      else if(a.unit)parts.push(nm+" "+amt+" "+a.unit);
      else parts.push(nm+" "+amt);
    }else parts.push(nm);
  });
  return parts.join(" + ");
}
function isPotassiumName(name){
  var nm=String(name||"").toLowerCase();
  return nm.indexOf("potassium")!==-1||/\bkcl\b/.test(nm)||/(^|\s)k\+/.test(nm);
}
function additiveValidation(){
  var errors=[],kTotal=0,kAny=false,hasBicarbonate=false,hasCalcium=false;
  additives.forEach(function(a,index){
    var name=String(a.name||"").trim();
    var amtRaw=String(a.amt||"").trim();
    var amount=strictDecimal(amtRaw);
    var label=name||("Additive "+(index+1));
    if(a.custom&&!name)errors.push("Enter a name for custom additive "+(index+1)+".");
    if(amount==null||amount<=0)errors.push(label+" needs a positive numeric amount.");
    if(["mmol/L","%"].indexOf(a.unit)===-1)errors.push(label+" is not expressed as a final bag concentration. Chart it separately after independently verifying bag volume, final concentration and compatibility.");
    var low=name.toLowerCase();
    if(low.indexOf("sodium bicarbonate")!==-1)hasBicarbonate=true;
    if(low.indexOf("calcium")!==-1)hasCalcium=true;
    if(isPotassiumName(name)){
      kAny=true;
      if(a.unit!=="mmol/L")errors.push(label+" has no final potassium concentration in mmol/L, so its infusion rate cannot be checked. Use the KCl preset or chart it separately.");
      else if(amount!=null&&amount>0)kTotal+=amount;
    }
  });
  var base=String($("fSel").value==="other"?($("fType").value||""):($("fSel").value||"")).toLowerCase();
  if(hasBicarbonate&&(hasCalcium||base.indexOf("hartmann")!==-1||base.indexOf("lrs")!==-1)){
    errors.push("Do not combine sodium bicarbonate with calcium-containing fluids or calcium additives because precipitation may occur.");
  }
  return {errors:errors,kTotal:kTotal,kAny:kAny};
}
function addAdditive(val){
  var bits=val.split("|");
  var custom=bits[0]==="other";
  if(!custom){
    for(var i=0;i<additives.length;i++){
      if(!additives[i].custom&&additives[i].name===bits[0]){
        notice("info","<b>Note.</b> "+escapeHtml(bits[0])+" is already in the bag. Edit its amount rather than adding it twice.");
        return;
      }
    }
  }
  additives.push({id:++addSeq,name:custom?"":bits[0],unit:bits[1]||"",custom:custom,amt:""});
  renderAdditives();
  fluidCalc();
}
function renderAdditives(){
  var wrap=$("addList");
  wrap.innerHTML="";
  additives.forEach(function(a){
    var row=document.createElement("div");
    row.className="addrow";
    if(a.custom){
      var nameInp=document.createElement("input");
      nameInp.className="acustom";nameInp.placeholder="Additive name";nameInp.value=a.name;
      nameInp.setAttribute("aria-label","Custom additive name");
      nameInp.addEventListener("input",function(){a.name=this.value;fluidCalc()});
      row.appendChild(nameInp);
    }else{
      var nm=document.createElement("span");
      nm.className="aname";nm.textContent=a.name;
      row.appendChild(nm);
    }
    var amtInp=document.createElement("input");
    amtInp.type="number";amtInp.min="0";amtInp.step="any";amtInp.inputMode="decimal";
    amtInp.placeholder="amount";amtInp.value=a.amt;
    amtInp.setAttribute("aria-label","Amount of "+(a.name||"additive")+(a.unit?" in "+a.unit:""));
    amtInp.addEventListener("input",function(){a.amt=this.value;fluidCalc()});
    row.appendChild(amtInp);
    if(a.unit){
      var hint=document.createElement("span");
      hint.className="ahint";hint.textContent=a.unit+(a.unit==="mmol/L"?" in bag":a.unit==="%"?" final in bag":"");
      row.appendChild(hint);
    }
    var rb=document.createElement("button");
    rb.className="rmbtn";rb.type="button";rb.innerHTML="×";
    rb.setAttribute("aria-label","Remove "+(a.name||"additive"));
    rb.addEventListener("click",function(){
      additives=additives.filter(function(x){return x.id!==a.id});
      renderAdditives();fluidCalc();
    });
    row.appendChild(rb);
    wrap.appendChild(row);
  });
}

/* ---------- fluid therapy ---------- */
function fluidNumbers(){
  var w=getWeight();
  if(!w)return null;
  var species=segState.segSpecies||"dog";
  var method=segState.segMethod||"formula";
  var custom=strictDecimal($("fCustom").value);
  var dehy=strictDecimal($("fDehy").value);
  var hours=strictDecimal($("fHours").value);
  var loss=strictDecimal($("fLoss").value);
  var first=parseInt($("fFirst").value,10);
  if(!isFinite(first)||first<0||first>23)first=0;
  var stop=stopHour("fStop");
  var errors=[];
  if(dehy==null||dehy<0||dehy>15)errors.push("Dehydration must be a number from 0% to 15%.");
  if(hours==null||hours<=0)errors.push("Deficit replacement time must be greater than zero hours.");
  if(loss==null||loss<0)errors.push("Ongoing losses must be zero or a positive number.");
  if(method==="custom"&&(custom==null||custom<=0))errors.push("Enter a custom maintenance rate greater than zero.");
  if($("fSel").value==="other"&&!($("fType").value||"").trim())errors.push("Enter the custom fluid name.");
  if(errors.length)return {w:w,species:species,first:first,stop:stop,errors:errors};
  var maintDay,maintExpr;
  if(method==="custom"){
    maintDay=custom*w;
    maintExpr=fmt(custom)+" ml/kg/day × "+fmt(w)+" kg";
  }else{
    var k=species==="cat"?80:132;
    maintDay=k*Math.pow(w,0.75);
    maintExpr=k+" × "+fmt(w)+"<sup>0.75</sup> kg";
  }
  var maintHr=maintDay/24;
  var defTotal=dehy*w*10;
  var defHr=defTotal/hours;
  var totalHr=maintHr+defHr+loss;
  return {w:w,species:species,first:first,stop:stop,dehy:dehy,hours:hours,loss:loss,maintDay:maintDay,maintHr:maintHr,maintExpr:maintExpr,defTotal:defTotal,defHr:defHr,totalHr:totalHr,mlkghr:totalHr/w,errors:[]};
}

function fluidCalc(){
  var box=$("fluidResult");
  var f=fluidNumbers();
  if(!f){
    box.innerHTML='<div class="rhead">Fluid plan</div><div class="working">Enter the body weight in Patient details to calculate fluid rates.</div>';
    checkFluidSync();
    return;
  }
  if(f.errors&&f.errors.length){
    box.innerHTML='<div class="rhead">Fluid plan</div>'+f.errors.map(function(msg){return '<div class="warn red"><b>Fix before charting.</b> '+escapeHtml(msg)+'</div>';}).join("");
    checkFluidSync();
    return;
  }
  var drip=function(dtf){return f.totalHr*dtf/60};
  var warns="";
  var av=additiveValidation();
  av.errors.forEach(function(msg){warns+='<div class="warn red" style="margin-top:10px"><b>Fix before charting.</b> '+escapeHtml(msg)+'</div>';});
  if(f.dehy>0&&f.hours<6)warns+='<div class="warn amber" style="margin-top:10px"><b>Caution.</b> Replacing the deficit over '+fmt(f.hours)+' hours is rapid. Confirm this is intentional and monitor closely; for shock use boluses, not a fast CRI.</div>';
  var kInfo="";
  if(av.kAny&&av.kTotal>0){
    var kPerKgHr=f.totalHr*av.kTotal/1000/f.w;
    var kMaxMl=0.5*f.w*1000/av.kTotal;
    if(kPerKgHr>0.5)warns+='<div class="warn red" style="margin-top:10px"><b>Critical: cannot add this plan to the chart.</b> Potassium delivery at this rate is '+fmt(kPerKgHr)+' mmol/kg/hr, above the maximum safe rate of 0.5 mmol/kg/hr. The maximum fluid rate for this bag ('+fmt(av.kTotal)+' mmol/L total potassium) in this patient is <b>'+fmt(kMaxMl)+' ml/hr</b>. Reduce the potassium concentration or the fluid rate.</div>';
    else kInfo='<div class="working">Potassium delivery: '+fmt(kPerKgHr)+' mmol/kg/hr (maximum 0.5 mmol/kg/hr), from '+fmt(av.kTotal)+' mmol/L total potassium. Maximum fluid rate with this bag: <b>'+fmt(kMaxMl)+' ml/hr</b>. Never bolus KCl-supplemented fluids; invert and mix the bag thoroughly and use a correctly configured infusion pump.</div>';
  }
  if(f.dehy>12)warns+='<div class="warn red" style="margin-top:10px"><b>Critical.</b> Dehydration above 12% is life-threatening hypovolaemia. Treat for shock with incremental boluses and reassess before relying on a 24 hour replacement plan.</div>';
  var capMlKgHr=f.species==="cat"?5:10;
  if(f.mlkghr>capMlKgHr)warns+='<div class="warn amber" style="margin-top:10px"><b>Caution.</b> Total rate is '+fmt(f.mlkghr)+' ml/kg/hr, above a typical '+(f.species==="cat"?"feline":"canine")+' comfort range. Recheck the inputs and monitor closely for fluid overload (respiratory rate, chemosis, weight gain), especially in cardiac or renal patients.</div>';
  box.innerHTML=
    '<div class="rhead">Fluid plan from '+pad2(f.first)+':00 '+stopPhrase(f.stop)+': '+escapeHtml(fluidLabel())+'</div>'+
    '<div class="bigcard"><div class="bignum">'+fmt(f.totalHr)+' <small>ml/hr on the pump</small></div>'+
    '<div class="metaline"><span>Maintenance <b>'+fmt(f.maintHr)+' ml/hr</b></span><span>Deficit <b>'+fmt(f.defHr)+' ml/hr</b></span><span>Ongoing losses <b>'+fmt(f.loss)+' ml/hr</b></span><span>Overall <b>'+fmt(f.mlkghr)+' ml/kg/hr</b></span></div></div>'+
    '<div class="bigcard"><div class="metaline"><span>Drip 15 dpm/ml <b>'+fmt(drip(15))+' drops/min</b></span><span>20 dpm/ml <b>'+fmt(drip(20))+' drops/min</b></span><span>60 dpm/ml <b>'+fmt(drip(60))+' drops/min</b></span></div></div>'+
    '<div class="working">Working: maintenance = '+f.maintExpr+' = '+fmt(f.maintDay)+' ml/day ÷ 24 = '+fmt(f.maintHr)+' ml/hr. '+
    'Deficit = '+fmt(f.dehy)+'% × '+fmt(f.w)+' kg × 10 = '+fmt(f.defTotal)+' ml over '+fmt(f.hours)+' h = '+fmt(f.defHr)+' ml/hr. '+
    'Total = '+fmt(f.maintHr)+' + '+fmt(f.defHr)+' + '+fmt(f.loss)+' = '+fmt(f.totalHr)+' ml/hr.</div>'+
    '<div class="working">Shock resuscitation is separate from this plan: give incremental boluses (dog 10-20 ml/kg, cat 5-10 ml/kg over 15-20 minutes) and reassess between boluses.</div>'+
    '<div class="working">This is the crystalloid pump rate only. Account separately for enteral water, liquid diet, CRI carriers and IV medication volumes when setting the patient\'s total fluid intake.</div>'+
    kInfo+
    warns;
  checkFluidSync();
}

/* the fluid row on the chart stores the rate it was created with; if the calculator now
   disagrees (weight or plan changed), warn instead of silently drifting apart */
function checkFluidSync(){
  var box=$("fluidStale");
  var fr=null;
  for(var i=0;i<meds.length;i++){if(meds[i].isFluid&&!meds[i].orderEnded){fr=meds[i];break;}}
  if(!fr||fr.fluidRate==null){box.innerHTML="";return false;}
  var f=fluidNumbers();
  if(!f){
    box.innerHTML='<div class="warn amber notice"><b>Caution.</b> The body weight has been cleared but the fluid row on the chart still shows '+fmt(fr.fluidRate)+' ml/hr. Re-enter the weight and press the fluids button to reconfirm the rate.</div>';
    return true;
  }
  var av=additiveValidation();
  if((f.errors&&f.errors.length)||av.errors.length){
    box.innerHTML='<div class="warn red notice"><b>Critical.</b> The fluid calculator contains invalid or incomplete inputs and no longer verifies the charted fluid row. Correct the plan and add it to the chart again before printing or copying.</div>';
    return true;
  }
  if(av.kTotal>0&&(f.totalHr*av.kTotal/1000/f.w)>0.5){
    box.innerHTML='<div class="warn red notice"><b>Critical.</b> The charted fluid plan would deliver potassium faster than 0.5 mmol/kg/hr. Do not administer, print or copy this order until the rate or concentration is corrected.</div>';
    return true;
  }
  var rateMismatch=Math.abs(f.totalHr-fr.fluidRate)>0.05;
  var labelMismatch=fr.fluidLabel!=null&&fr.fluidLabel!==fluidLabel();
  var startMismatch=Number(fr.first||0)!==f.first;
  var stopMismatch=(fr.stop==null?null:Number(fr.stop))!==f.stop;
  if(rateMismatch){
    box.innerHTML='<div class="warn amber notice"><b>Caution.</b> The fluid calculator no longer matches the chart. The chart row shows <b>'+fmt(fr.fluidRate)+' ml/hr</b> but the calculator now gives <b>'+fmt(f.totalHr)+' ml/hr</b>. Press "Add fluids to the 24 hour chart" to update the row, or revert the calculator inputs.</div>';
  }else if(labelMismatch||startMismatch||stopMismatch){
    box.innerHTML='<div class="warn amber notice"><b>Caution.</b> The fluid, additives, start or stop selected no longer match the chart row ("'+escapeHtml(fr.drug)+'"). Press "Add fluids to the 24 hour chart" to update the row, or revert the selection.</div>';
  }else{
    box.innerHTML="";
    return false;
  }
  return true;
}

function addFluidRow(){
  var f=fluidNumbers();
  if(!f){notice("amber","<b>Caution.</b> Enter the body weight before adding fluids to the chart.");return;}
  if(f.errors&&f.errors.length){notice("amber","<b>Caution.</b> "+escapeHtml(f.errors[0]));return;}
  var av=additiveValidation();
  if(av.errors.length){notice("amber","<b>Caution.</b> "+escapeHtml(av.errors[0]));return;}
  if(av.kTotal>0&&(f.totalHr*av.kTotal/1000/f.w)>0.5){
    notice("red","<b>Critical.</b> This plan exceeds 0.5 mmol/kg/hr of potassium and cannot be added to the chart. Reduce the pump rate or potassium concentration first.");return;
  }
  var label=fluidLabel();
  var doseText=fmt(f.totalHr)+" ml/hr";
  var existing=meds.filter(function(m){return m.isFluid&&!m.orderEnded})[0];
  if(existing){
    backfillGivenSnapshots(existing);
    reschedulePreservingGiven(existing,"cri",f.first,f.stop);
    existing.drug=label;
    existing.manual=doseText;
    existing.fluidRate=f.totalHr;
    existing.fluidLabel=label;
    notice("info","<b>Note.</b> The fluid row has been updated to "+escapeHtml(label)+" at "+doseText+" from "+pad2(f.first)+":00 "+stopPhrase(f.stop)+". Recorded checks retain their original fluid identity, rate, dose and weight snapshots.");
  }else{
    meds.push({id:++medSeq,drug:label,route:"IV",rate:null,conc:null,manual:doseText,freq:"cri",first:f.first,stop:f.stop,isFluid:true,fluidRate:f.totalHr,fluidLabel:label,cells:scheduleCells("cri",f.first,false,f.stop)});
    notice("info","<b>Note.</b> Fluids added to the chart from "+pad2(f.first)+":00 "+stopPhrase(f.stop)+" at "+doseText+". If the body weight or plan changes, recalculate and press the button again to update the row.");
  }
  renderBody();
}

/* ---------- CRI form ---------- */
function criFormVals(){
  var first=parseInt($("cFirst").value,10);
  if(!isFinite(first)||first<0||first>23)first=0;
  return {drug:($("cDrug").value||"").trim(),rate:parseFloat($("cRate").value),unit:$("cUnit").value,conc:parseFloat($("cConc").value),first:first,stop:stopHour("cStop")};
}
function renderCriPreview(){
  var v=criFormVals(),w=getWeight(),box=$("criPreview");
  if(!(isFinite(v.rate)&&v.rate>0&&isFinite(v.conc)&&v.conc>0)){box.innerHTML="";return;}
  if(!w){box.innerHTML='<div class="warn amber notice">Enter the body weight to calculate the CRI rate.</div>';return;}
  var mgHr=criMgPerHr(v.rate,v.unit,w);
  var mlHr=mgHr/v.conc;
  var extra=mlHr>30?'<div class="warn amber notice"><b>Caution.</b> '+fmt(mlHr)+' ml/hr is unusually fast for a syringe driver. Check the rate unit and the syringe concentration, or consider a more concentrated dilution.</div>':"";
  box.innerHTML='<div class="warn info notice">From '+pad2(v.first)+':00 '+stopPhrase(v.stop)+': '+fmt(v.rate)+' '+CRI_UNITS[v.unit]+' × '+fmt(w)+' kg = '+fmt(mgHr)+' mg/hr ÷ '+fmt(v.conc)+' mg/ml = <b>'+fmt(mlHr)+' ml/hr</b> on the driver.</div>'+extra;
}
function addCri(){
  var v=criFormVals();
  if(!v.drug){notice("amber","<b>Caution.</b> Enter the CRI drug name.");$("cDrug").focus();return;}
  if(!(isFinite(v.rate)&&v.rate>0)||!(isFinite(v.conc)&&v.conc>0)){notice("amber","<b>Caution.</b> Enter the CRI rate and the syringe concentration (mg/ml).");return;}
  if(!getWeight()){notice("amber","<b>Caution.</b> Enter the body weight before adding a CRI to the chart.");return;}
  var existing=meds.filter(function(m){return !m.orderEnded&&m.cri&&String(m.drug||"").toLowerCase()===v.drug.toLowerCase()})[0];
  if(existing){
    backfillGivenSnapshots(existing);
    reschedulePreservingGiven(existing,"cri",v.first,v.stop);
    existing.cri={rate:v.rate,unit:v.unit,conc:v.conc};
    notice("info","<b>Note.</b> The "+escapeHtml(v.drug)+" CRI was updated from "+pad2(v.first)+":00 "+stopPhrase(v.stop)+". Recorded administrations retain their original rate, concentration, dose and weight snapshots.");
  }else{
    meds.push({id:++medSeq,drug:v.drug,route:"IV",unit:"mgkg",rate:null,conc:null,manual:null,freq:"cri",first:v.first,stop:v.stop,isFluid:false,cri:{rate:v.rate,unit:v.unit,conc:v.conc},cells:scheduleCells("cri",v.first,false,v.stop)});
    notice("","");
  }
  $("cDrug").value="";$("cRate").value="";$("cConc").value="";
  renderCriPreview();
  renderBody();
}

/* ---------- NGT feeding ---------- */
function addNg(){
  var amt=parseFloat($("nAmt").value);
  if(!(isFinite(amt)&&amt>0)){notice("amber","<b>Caution.</b> Enter the NGT feeding amount in ml.");$("nAmt").focus();return;}
  var mode=$("nMode").value;
  var first=parseInt($("nFirst").value,10);
  if(!isFinite(first)||first<0||first>23)first=8;
  var isCri=mode==="cri";
  var freq=isCri?"cri":mode;
  var stop=isCri?stopHour("nStop"):null;
  var manual=isCri?fmt(amt)+" ml/hr (CRI)":fmt(amt)+" ml bolus";
  var cellText=fmt(amt)+"ml";
  var existing=null;
  for(var i=0;i<meds.length;i++)if(meds[i].isNg&&!meds[i].orderEnded){existing=meds[i];break;}
  if(existing){
    backfillGivenSnapshots(existing);
    /* Preserve every administration snapshot, even when its hour is not in the new schedule. */
    var oldGiven=existing.given||{};
    var oldDetails=existing.givenDetails||{};
    var oldCells=existing.cells||{};
    existing.freq=freq;existing.first=first;existing.stop=stop;existing.manual=manual;existing.cellText=cellText;existing.ngCri=isCri;
    existing.cells=scheduleCells(freq,first,false,stop);
    delete existing.stopReached;delete existing.orderEnded;
    existing.continued=false;
    var newGiven={},newDetails={},kept=0;
    Object.keys(oldCells).forEach(function(h){
      if(oldCells[h]===2){
        existing.cells[h]=2;
        if(oldGiven[h])newGiven[h]=oldGiven[h];
        if(oldDetails[h])newDetails[h]=oldDetails[h];
        kept++;
      }
    });
    if(Object.keys(newGiven).length)existing.given=newGiven;else delete existing.given;
    if(Object.keys(newDetails).length)existing.givenDetails=newDetails;else delete existing.givenDetails;
    notice("info","<b>Note.</b> The NGT feeding row has been updated to "+manual+(isCri?" "+stopPhrase(stop):"")+"."+(kept?" All "+kept+" recorded administration"+(kept>1?"s were":" was")+" retained with the original dose snapshot.":""));
  }else{
    meds.push({id:++medSeq,drug:"NGT feeding",route:"NGT",rate:null,conc:null,manual:manual,cellText:cellText,freq:freq,first:first,stop:stop,isNg:true,ngCri:isCri,cells:scheduleCells(freq,first,false,stop)});
    notice("","");
  }
  $("nAmt").value="";
  renderBody();
}

/* ---------- NPO chart marking ---------- */
function npoCells(start,end){
  var c={},h;
  if(end==null){for(h=start;h<24;h++)c[h]=1;}
  else if(end>start){for(h=start;h<end;h++)c[h]=1;}
  else{for(h=start;h<24;h++)c[h]=1;} /* end at or before start: runs to midnight; tomorrow's cells appear on the next day's sheet */
  return c;
}
function npoMeta(m){
  if(m.orderEnded)return "NPO order ended"+(endedWhen(m)?" at "+endedWhen(m):"")+(m.npoHistory&&m.npoHistory.length?" ("+m.npoHistory.length+" prior revision"+(m.npoHistory.length>1?"s":"")+" archived)":"");
  if(m.npoContinued&&Object.keys(m.cells||{}).length){
    return m.npo.end==null?"NPO continuing from the previous day until further notice":"NPO continuing from the previous day until "+pad2(m.npo.end)+":00";
  }
  var s="Nothing by mouth from "+pad2(m.npo.start)+":00";
  if(m.npo.end==null)s+=" until further notice";
  else if(m.npo.end===0)s+=m.npo.start===0?" until 00:00 tomorrow (continues for 24 hours)":" until midnight";
  else if(m.npo.end===m.npo.start)s+=" until "+pad2(m.npo.end)+":00 tomorrow (continues after midnight)";
  else if(m.npo.end<m.npo.start)s+=" until "+pad2(m.npo.end)+":00 (continues after midnight)";
  else s+=" until "+pad2(m.npo.end)+":00";
  if(m.npoDone&&Object.keys(m.cells).length===0)s+=" (ended on a previous day)";
  if(m.npoHistory&&m.npoHistory.length)s+=" ("+m.npoHistory.length+" prior revision"+(m.npoHistory.length>1?"s":"")+" archived)";
  return s;
}
function addNpo(){
  var start=parseInt($("npoStart").value,10);
  if(!isFinite(start)||start<0||start>23)start=0;
  var ev=$("npoEnd").value;
  var end=ev==="noend"?null:parseInt(ev,10);
  var existing=null;
  for(var i=0;i<meds.length;i++)if(meds[i].type==="npo"){existing=meds[i];break;}
  if(existing){
    existing.npoHistory=existing.npoHistory||[];
    existing.npoHistory.push({npo:{start:existing.npo.start,end:existing.npo.end},cells:Object.assign({},existing.cells||{}),instruction:String(existing.npoInstruction||""),revisedAt:new Date().toISOString(),chartDate:$("iDate").value||null});
    existing.npo={start:start,end:end};
    existing.npoInstruction=($("iNPO").value||"").trim();
    existing.cells=npoCells(start,end);
    delete existing.orderEnded;
    delete existing.endedAt;
    delete existing.npoDone;
    delete existing.npoContinued;
    notice("info","<b>Note.</b> The NPO marking on the chart has been updated.");
  }else{
    meds.push({id:++medSeq,type:"npo",drug:"NPO",route:"",rate:null,conc:null,manual:null,freq:"once",first:start,npo:{start:start,end:end},npoInstruction:($("iNPO").value||"").trim(),cells:npoCells(start,end)});
    notice("","");
  }
  renderAlerts();
  renderBody();
}
function paintNpoCell(td,m,h){
  var on=(m.cells[h]||0)===1;
  td.classList.toggle("npocell",on);
  td.classList.remove("due","given","prncell","val");
  td.setAttribute("aria-label",on?("NPO at "+pad2(h)+":00, nothing by mouth"):("NPO row, "+pad2(h)+":00, not restricted"));
  td.innerHTML=on?'<span class="cdose">NPO</span>':"";
}

/* ---------- nebulisation ---------- */
function addNeb(){
  var medsTxt=($("nbMeds").value||"").trim();
  if(!medsTxt){notice("amber","<b>Caution.</b> Enter the medications going into the neb solution.");$("nbMeds").focus();return;}
  var vol=parseFloat($("nbVol").value);
  if(!(isFinite(vol)&&vol>0)){notice("amber","<b>Caution.</b> Enter the total solution volume in ml (made up with 0.9% saline).");return;}
  var mins=parseFloat($("nbMin").value);
  if(!(isFinite(mins)&&mins>0)){notice("amber","<b>Caution.</b> Enter how many minutes each nebulisation runs.");return;}
  var freq=$("nbFreq").value;
  var first=parseInt($("nbFirst").value,10);
  if(!isFinite(first)||first<0||first>23)first=8;
  var manual=medsTxt+" in "+fmt(vol)+" ml 0.9% saline, run over "+fmt(mins)+" min";
  meds.push({id:++medSeq,drug:"Nebulisation",route:"INH",rate:null,conc:null,manual:manual,cellText:fmt(mins)+"min",freq:freq,first:first,cells:scheduleCells(freq,first)});
  notice("","");
  $("nbMeds").value="";
  renderBody();
}

/* ---------- oxygen therapy ---------- */
function oxyLine(m){
  var o=m.oxy;
  var s;
  if(o.unit==="lkgmin"){
    var w=getWeight();
    if(!w)return '<span style="color:var(--red);font-weight:700">'+fmt(o.rate)+' L/kg/min: enter body weight to calculate the flow</span>';
    s=fmt(o.rate)+" L/kg/min × "+fmt(w)+" kg = <b>"+fmt(o.rate*w)+" L/min</b>";
  }else{
    s="<b>"+fmt(o.rate)+" L/min</b>";
  }
  s+=" via "+escapeHtml(o.via);
  if(o.fio!=null)s+=" (target FiO2 "+fmt(o.fio)+"%)";
  if(o.unit==="lkgmin"&&o.rate>2.5)s+=' <span style="color:var(--amber);font-weight:700">above the typical high-flow range of 1-2 L/kg/min: check the rate</span>';
  return s;
}
function oxyText(m){
  var o=m.oxy;
  var w=getWeight();
  var s;
  if(o.unit==="lkgmin")s=w?(fmt(o.rate)+" L/kg/min ("+fmt(o.rate*w)+" L/min)"):(fmt(o.rate)+" L/kg/min (enter weight)");
  else s=fmt(o.rate)+" L/min";
  s+=" via "+o.via;
  if(o.fio!=null)s+=", target FiO2 "+fmt(o.fio)+"%";
  return s;
}
function addOxy(){
  var rate=parseFloat($("oxRate").value);
  if(!(isFinite(rate)&&rate>0)){notice("amber","<b>Caution.</b> Enter the oxygen rate.");$("oxRate").focus();return;}
  var unit=$("oxUnit").value;
  if(unit==="lkgmin"&&!getWeight()){notice("amber","<b>Caution.</b> L/kg/min needs the body weight. Enter it in Patient details first.");return;}
  var via=$("oxVia").value;
  var fioRaw=($("oxFio").value||"").trim();
  var fio=fioRaw===""?null:Number(fioRaw);
  if(fioRaw!==""&&!(isFinite(fio)&&fio>=21&&fio<=100)){notice("amber","<b>Caution.</b> FiO2 must be between 21% and 100%, or left blank.");$("oxFio").focus();return;}
  var first=parseInt($("oxFirst").value,10);
  if(!isFinite(first)||first<0||first>23)first=0;
  var stop=stopHour("oxStop");
  var o={rate:rate,unit:unit,via:via,fio:fio};
  var existing=null;
  for(var i=0;i<meds.length;i++)if(meds[i].isOxy&&!meds[i].orderEnded){existing=meds[i];break;}
  if(existing){
    backfillGivenSnapshots(existing);
    reschedulePreservingGiven(existing,"cri",first,stop);
    existing.oxy=o;
    notice("info","<b>Note.</b> The oxygen row has been updated from "+pad2(first)+":00 "+stopPhrase(stop)+": "+escapeHtml(oxyText(existing))+". Recorded checks retain their original snapshots.");
  }else{
    meds.push({id:++medSeq,drug:"Oxygen",route:"O2",rate:null,conc:null,manual:null,cellText:"O2",freq:"cri",first:first,stop:stop,isOxy:true,oxy:o,cells:scheduleCells("cri",first,false,stop)});
    notice("","");
  }
  renderBody();
}

/* ---------- multi-day ---------- */
function startNextDay(){
  meds.forEach(function(m){
    if(m.type==="npo"){
      if(m.orderEnded){m.cells={};return;}
      if(m.npoDone){m.cells={};}
      else if(m.npo.end==null){
        var ca={};for(var ha=0;ha<24;ha++)ca[ha]=1;m.cells=ca;m.npoContinued=true;
      }else if(m.npo.end<=m.npo.start){
        var cb={};for(var hb=0;hb<m.npo.end;hb++)cb[hb]=1;m.cells=cb;m.npoDone=true;m.npoContinued=true;
      }else{
        m.cells={};m.npoDone=true;delete m.npoContinued;
      }
      return;
    }
    if(m.orderEnded){
      m.cells={};m.continued=false;
    }else if(m.freq==="once"){
      /* a once-only order must never resurrect as due after it has been given
         (repeat-administration hazard for loading doses and long-acting injections) */
      var hadGiven=(m.given&&Object.keys(m.given).length>0)||Object.keys(m.cells).some(function(h){return m.cells[h]===2})||(m.type==="obs"&&m.vals&&Object.keys(m.vals).length>0);
      if(hadGiven||m.prevGiven){m.prevGiven=true;m.cells={};}
      else m.cells=scheduleCells(m.freq,m.first,true);
    }else if(m.freq==="cri"||m.ngCri){
      if(m.orderEnded||m.stopReached){
        m.cells={};m.orderEnded=true;m.continued=false;
      }else if(m.stop==null){
        m.cells=scheduleCells(m.freq,m.first,true,null);m.continued=true;
      }else if(m.stop>m.first){
        /* This order ended later on its starting chart day. */
        m.cells={};m.stopReached=true;m.orderEnded=true;m.continued=false;
      }else{
        /* The stop crosses midnight; show only the hours before that stop on this next day. */
        m.cells={};for(var hc=0;hc<m.stop;hc++)m.cells[hc]=1;
        m.stopReached=true;m.continued=m.stop>0;
        if(m.stop===0)m.orderEnded=true;
      }
    }else{
      m.cells=scheduleCells(m.freq,m.first,true);
    }
    m.history=m.history||[];
    Object.keys(m.given||{}).forEach(function(h){
      m.history.push({kind:"administration",chartDate:$("iDate").value||null,day:$("iDay").value||null,hour:Number(h),detail:(m.givenDetails&&m.givenDetails[h])||{time:m.given[h]}});
    });
    if(m.type==="obs"){
      Object.keys(m.vals||{}).forEach(function(h){m.history.push({kind:"observation",chartDate:$("iDate").value||null,day:$("iDay").value||null,hour:Number(h),value:m.vals[h]});});
      m.vals={};
    }
    delete m.given;
    delete m.givenDetails;
  });
  var d=parseInt($("iDay").value,10);
  $("iDay").value=String((isFinite(d)?d:1)+1);
  var dt=$("iDate").value;
  if(dt){
    var parts=dt.split("-");
    if(parts.length===3){
      var dd=new Date(parseInt(parts[0],10),parseInt(parts[1],10)-1,parseInt(parts[2],10)+1);
      $("iDate").value=dd.getFullYear()+"-"+pad2(dd.getMonth()+1)+"-"+pad2(dd.getDate());
    }
  }
  notice("info","<b>Note.</b> Started day "+$("iDay").value+". The previous day's administrations and observations were archived inside the saved chart data, visible ticks were cleared, and schedules were reset. Once-only medications already given remain marked as previous-day orders with no new due time.");
  renderBody();
  renderAlerts();
}

/* ---------- save / load chart file ---------- */
var FIELD_IDS=["iDate","iDay","iClinic","iDept","iClient","iPatientNo","iName","iDr","iAge","iSex","iWeight","iReason","iDietText","iNPO","iNotes","iDietKcal","iDietUnit","iMeals","fSel","fType","fFirst","fStop","fCustom","fDehy","fHours","fLoss"];
var SEG_IDS=["segCode","segBeh","segBarrier","segImm","segInf","segChemo","segSz","segDiet","segSpecies","segDesexed","segWU","segMethod"];
function chartToJson(){
  var o={v:1,app:"askavet-hospital-chart",fields:{},segs:{},additives:additives,meds:meds};
  FIELD_IDS.forEach(function(id){o.fields[id]=$(id).value});
  SEG_IDS.forEach(function(id){o.segs[id]=segState[id]||null});
  return JSON.stringify(o);
}
function saveChart(){
  var json=chartToJson();
  appRoot.__lastExport=json;
  try{
    var blob=new Blob([json],{type:"application/json"});
    var a=document.createElement("a");
    a.href=URL.createObjectURL(blob);
    var nm=(($("iName").value||"").trim().replace(/[^a-z0-9]+/gi,"-").toLowerCase())||"patient";
    a.download=nm+"-day"+((($("iDay").value||"").trim())||"1")+"-chart.json";
    document.body.appendChild(a);a.click();document.body.removeChild(a);
    setTimeout(function(){URL.revokeObjectURL(a.href)},2000);
    notice("ok","<b>Saved.</b> Chart file downloaded. Open it tomorrow or on another computer with \"Load chart file\". If no file appeared, your browser blocked the download; use Copy chart summary as a backup.");
  }catch(e){
    notice("amber","<b>Caution.</b> Could not download the file in this environment. Use Copy chart summary instead.");
  }
}
function own(obj,key){return Object.prototype.hasOwnProperty.call(obj,key)}
function safeString(value,max){
  if(typeof value!=="string")return "";
  return value.slice(0,max||5000);
}
function defaultField(id){
  var now=new Date();
  var defaults={
    iDate:now.getFullYear()+"-"+pad2(now.getMonth()+1)+"-"+pad2(now.getDate()),
    iDay:"",iClinic:"",iDept:"",iClient:"",iPatientNo:"",iName:"",iDr:"",iAge:"",iSex:"",
    iWeight:"",iReason:"",iDietText:"",iNPO:"",iNotes:"",iDietKcal:"",iDietUnit:"100g",iMeals:"4",
    fSel:"Hartmann's (LRS)",fType:"",fFirst:"0",fStop:"noend",fCustom:"50",fDehy:"0",fHours:"24",fLoss:"0"
  };
  return own(defaults,id)?defaults[id]:"";
}
var SEG_ALLOWED={
  segCode:["CPR","DNR"],segBeh:["Calm","Anxious","Aggressive"],segBarrier:["None","Gloves","Full PPE"],
  segImm:["No","Yes"],segInf:["No","Yes"],segChemo:["No","Yes"],segSz:["No","Yes"],segDiet:["No","Yes"],
  segSpecies:["dog","cat"],segDesexed:["Yes","No"],segWU:["kg","lb"],segMethod:["formula","custom"]
};
var SEG_DEFAULTS={segCode:null,segBeh:null,segBarrier:null,segImm:null,segInf:null,segChemo:null,segSz:null,segDiet:null,segSpecies:"dog",segDesexed:null,segWU:"kg",segMethod:"formula"};
function normalizedHour(value,label){
  var n=Number(value);
  if(!Number.isInteger(n)||n<0||n>23)throw new Error(label+" has an invalid hour.");
  return n;
}
function normalizedIso(value,label){
  if(value==null||value==="")return null;
  if(typeof value!=="string"||!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{1,3})?Z$/.test(value)||!isFinite(Date.parse(value)))throw new Error(label+" has an invalid timestamp.");
  return value;
}
function normalizeCells(raw,label){
  if(raw==null)return {};
  if(typeof raw!=="object"||Array.isArray(raw))throw new Error(label+" has invalid chart cells.");
  var out={};
  Object.keys(raw).forEach(function(key){
    var h=Number(key),state=Number(raw[key]);
    if(!Number.isInteger(h)||h<0||h>23)throw new Error(label+" has a chart cell outside 00:00 to 23:00.");
    if(typeof raw[key]!=="number"||(state!==1&&state!==2))throw new Error(label+" has an invalid chart-cell state.");
    out[h]=state;
  });
  return out;
}
function normalizeHourTextMap(raw,label,maxLen){
  if(raw==null)return {};
  if(typeof raw!=="object"||Array.isArray(raw))throw new Error(label+" has invalid recorded values.");
  var out={};
  Object.keys(raw).forEach(function(key){
    var h=Number(key);
    if(!Number.isInteger(h)||h<0||h>23)throw new Error(label+" has a recorded value outside 00:00 to 23:00.");
    if(typeof raw[key]!=="string")throw new Error(label+" has a recorded value with an invalid type.");
    out[h]=raw[key].slice(0,maxLen||200);
  });
  return out;
}
function positiveOrNull(value,label){
  if(value==null)return null;
  if(typeof value==="number"&&isFinite(value)&&value>0)return value;
  throw new Error((label||"A numeric value")+" must be a positive number.");
}
function normalizeGivenDetails(raw){
  if(raw==null)return {};
  if(typeof raw!=="object"||Array.isArray(raw))throw new Error("A medication has invalid administration details.");
  var out={};
  Object.keys(raw).forEach(function(key){
    var h=Number(key),d=raw[key];
    if(!Number.isInteger(h)||h<0||h>23)throw new Error("An administration detail is outside 00:00 to 23:00.");
    if(!d||typeof d!=="object"||Array.isArray(d))throw new Error("An administration detail is invalid.");
    if(typeof d.time!=="string"||!/^(?:[01]\d|2[0-3]):[0-5]\d$/.test(d.time))throw new Error("An administration detail has no valid recorded time.");
    if(d.recordedAt!=null&&typeof d.recordedAt!=="string")throw new Error("An administration detail has an invalid timestamp.");
    if(d.weightKg!=null&&!(typeof d.weightKg==="number"&&isFinite(d.weightKg)&&d.weightKg>0))throw new Error("An administration detail has an invalid weight.");
    if(d.dose!=null&&typeof d.dose!=="string")throw new Error("An administration detail has an invalid dose snapshot.");
    var item={
      time:safeString(d.time,20),
      recordedAt:d.recordedAt?normalizedIso(d.recordedAt,"An administration detail"):"",
      weightKg:typeof d.weightKg==="number"&&isFinite(d.weightKg)&&d.weightKg>0?d.weightKg:null,
      dose:safeString(d.dose,300)
    };
    out[h]=item;
  });
  return out;
}
function normalizeMed(raw,index){
  if(!raw||typeof raw!=="object"||Array.isArray(raw))throw new Error("Medication row "+(index+1)+" is invalid.");
  var drug=safeString(raw.drug,300).trim();
  if(!drug)throw new Error("Medication row "+(index+1)+" has no name.");
  var freq=safeString(raw.freq,20);
  if(!own(FREQ,freq))throw new Error(drug+" has an unsupported frequency.");
  var type=raw.type==null?null:safeString(raw.type,20);
  if(type!==null&&type!==""&&type!=="obs"&&type!=="npo")throw new Error(drug+" has an unsupported row type.");
  var first=normalizedHour(raw.first==null?0:raw.first,drug);
  var stop=raw.stop==null?null:normalizedHour(raw.stop,drug+" stop");
  var allowedUnits=["mgkg","mcgkg","mg","ml"];
  if(raw.rate!=null&&raw.unit==null)throw new Error(drug+" has a numeric dose but no dose unit.");
  if(raw.unit!=null&&allowedUnits.indexOf(raw.unit)===-1)throw new Error(drug+" has an unsupported dose unit.");
  var unit=raw.unit==null?"mgkg":raw.unit;
  var kindCount=(type==="obs"?1:0)+(type==="npo"?1:0)+(raw.isFluid?1:0)+(raw.isNg?1:0)+(raw.isOxy?1:0)+(raw.cri!=null?1:0);
  if(kindCount>1)throw new Error(drug+" combines incompatible row types.");
  if(raw.ngCri&&!raw.isNg)throw new Error(drug+" has NGT CRI settings without an NGT row.");
  if((raw.oxy!=null)!==!!raw.isOxy)throw new Error(drug+" has contradictory oxygen settings.");
  var m={
    id:index+1,drug:drug,route:safeString(raw.route,80),unit:unit,
    prn:!!raw.prn,rate:positiveOrNull(raw.rate,drug+" dose"),conc:positiveOrNull(raw.conc,drug+" concentration"),tab:positiveOrNull(raw.tab,drug+" tablet strength"),
    manual:safeString(raw.manual,500).trim()||null,freq:freq,first:first,stop:stop,cells:normalizeCells(raw.cells,drug),
    isFluid:!!raw.isFluid,isNg:!!raw.isNg,ngCri:!!raw.ngCri,isOxy:!!raw.isOxy,
    cellText:safeString(raw.cellText,80)||null,prevGiven:!!raw.prevGiven,continued:!!raw.continued,stopReached:!!raw.stopReached,orderEnded:!!raw.orderEnded,endedAt:normalizedIso(raw.endedAt,drug)
  };
  if(m.endedAt&&!m.orderEnded)throw new Error(drug+" has a discontinuation timestamp but is still marked active.");
  if(m.orderEnded&&Object.keys(m.cells).some(function(h){return m.cells[h]===1;}))throw new Error(drug+" is discontinued but still has due cells.");
  if(stop!=null&&freq!=="cri"&&!m.ngCri)throw new Error(drug+" has a stop time but is not a continuous order.");
  if(m.tab!=null&&["PO","NGT","In food"].indexOf(m.route)===-1)throw new Error(drug+" has a tablet strength paired with a non-enteral route.");
  if(type)m.type=type;
  var given=normalizeHourTextMap(raw.given,drug,20);
  var details=normalizeGivenDetails(raw.givenDetails);
  Object.keys(given).forEach(function(h){if(!/^(?:[01]\d|2[0-3]):[0-5]\d$/.test(given[h]))throw new Error(drug+" has an invalid administration time.");});
  Object.keys(m.cells).forEach(function(h){if(m.cells[h]===2&&!own(given,h))throw new Error(drug+" has a given chart cell without a matching administration record.");});
  Object.keys(details).forEach(function(h){
    if(!own(given,h))throw new Error(drug+" has an administration detail without a matching recorded administration.");
    if(details[h].time!==given[h])throw new Error(drug+" has conflicting administration times.");
  });
  Object.keys(given).forEach(function(h){m.cells[h]=2;});
  if(freq==="once"&&type!=="npo"){
    var onceGiven=Object.keys(given);
    var onceActionable=Object.keys(m.cells).filter(function(h){return m.cells[h]===1||m.cells[h]===2;});
    if(onceGiven.length>1||onceActionable.length>1||(m.prevGiven&&onceActionable.length))throw new Error(drug+" has contradictory once-only dose records.");
  }
  if(Object.keys(given).length)m.given=given;
  if(Object.keys(details).length)m.givenDetails=details;
  if(raw.audit!=null&&!Array.isArray(raw.audit))throw new Error(drug+" has an invalid audit trail.");
  if(raw.history!=null&&!Array.isArray(raw.history))throw new Error(drug+" has invalid prior-day history.");
  if(Array.isArray(raw.audit)){
    raw.audit.forEach(function(item){if(!item||typeof item!=="object"||Array.isArray(item))throw new Error(drug+" has an invalid audit-trail entry.");});
    m.audit=raw.audit.slice();
  }
  if(Array.isArray(raw.history)){
    raw.history.forEach(function(item){if(!item||typeof item!=="object"||Array.isArray(item))throw new Error(drug+" has an invalid prior-day history entry.");});
    m.history=raw.history.slice();
  }
  if(raw.vals!=null&&type!=="obs")throw new Error(drug+" has observation values on a non-observation row.");
  if((raw.npo!=null||raw.npoHistory!=null||raw.npoInstruction!=null||raw.npoDone!=null||raw.npoContinued!=null)&&type!=="npo")throw new Error(drug+" has NPO data on a non-NPO row.");
  if(raw.npoHistory!=null&&!Array.isArray(raw.npoHistory))throw new Error("The NPO revision history is invalid.");
  if((type==="obs"||type==="npo")&&(Object.keys(given).length||Object.keys(details).length))throw new Error(drug+" has medication-administration records on a non-medication row.");
  if(type==="obs"){
    m.vals=normalizeHourTextMap(raw.vals,drug,300);
    if(freq==="once"){
      var onceValueKeys=Object.keys(m.vals);
      var onceObsKeys={};
      Object.keys(m.cells).forEach(function(h){if(m.cells[h]===1||m.cells[h]===2)onceObsKeys[h]=true;});
      onceValueKeys.forEach(function(h){onceObsKeys[h]=true;});
      if(onceValueKeys.length>1||Object.keys(onceObsKeys).length>1||(m.prevGiven&&Object.keys(onceObsKeys).length))throw new Error(drug+" has contradictory once-only observation records.");
    }
  }
  if(type==="npo"){
    if(!raw.npo||typeof raw.npo!=="object"||Array.isArray(raw.npo))throw new Error("The NPO row is missing its time range.");
    var end=raw.npo.end==null?null:normalizedHour(raw.npo.end,"NPO");
    m.npo={start:normalizedHour(raw.npo.start,"NPO"),end:end};
    m.npoInstruction=typeof raw.npoInstruction==="string"?safeString(raw.npoInstruction,1000).trim():null;
    m.npoDone=!!raw.npoDone;
    m.npoContinued=!!raw.npoContinued;
    if(Array.isArray(raw.npoHistory))m.npoHistory=raw.npoHistory.map(function(item){
      if(!item||typeof item!=="object"||Array.isArray(item)||!item.npo||typeof item.npo!=="object"||Array.isArray(item.npo))throw new Error("The NPO revision history is invalid.");
      if(typeof item.instruction!=="string"||typeof item.revisedAt!=="string"||(item.chartDate!=null&&typeof item.chartDate!=="string"))throw new Error("The NPO revision history has invalid text or timestamps.");
      return {npo:{start:normalizedHour(item.npo.start,"NPO history"),end:item.npo.end==null?null:normalizedHour(item.npo.end,"NPO history")},cells:normalizeCells(item.cells,drug+" NPO history"),instruction:safeString(item.instruction,1000),revisedAt:normalizedIso(item.revisedAt,"NPO history"),chartDate:safeString(item.chartDate,20)};
    });
  }
  if(raw.cri!=null){
    if(!raw.cri||typeof raw.cri!=="object"||Array.isArray(raw.cri)||!own(CRI_UNITS,raw.cri.unit))throw new Error(drug+" has invalid CRI settings.");
    if(freq!=="cri")throw new Error(drug+" has CRI settings but is not a continuous row.");
    var cr=positiveOrNull(raw.cri.rate,drug+" CRI rate"),cc=positiveOrNull(raw.cri.conc,drug+" CRI concentration");
    m.cri={rate:cr,unit:raw.cri.unit,conc:cc};
  }
  if(raw.oxy!=null){
    if(!raw.oxy||typeof raw.oxy!=="object"||Array.isArray(raw.oxy))throw new Error("The oxygen row has invalid settings.");
    if(freq!=="cri")throw new Error("The oxygen row is not continuous.");
    var orate=positiveOrNull(raw.oxy.rate,"The oxygen rate");
    if(["lmin","lkgmin"].indexOf(raw.oxy.unit)===-1)throw new Error("The oxygen row has an invalid rate or unit.");
    var fio=raw.oxy.fio==null?null:Number(raw.oxy.fio);
    if(fio!=null&&(!isFinite(fio)||fio<21||fio>100))throw new Error("The oxygen row has an invalid FiO2.");
    m.oxy={rate:orate,unit:raw.oxy.unit,via:safeString(raw.oxy.via,100)||"Other",fio:fio};
  }
  if(m.isFluid){
    if(freq!=="cri")throw new Error("The fluid row is not continuous.");
    var fluidRate=Number(raw.fluidRate);
    if(!isFinite(fluidRate)||fluidRate<=0)throw new Error("The fluid row has an invalid rate.");
    if(!m.manual)throw new Error("The fluid row has no displayed pump rate.");
    m.fluidRate=fluidRate;
    m.fluidLabel=safeString(raw.fluidLabel,500)||drug;
  }
  var special=type==="obs"||type==="npo"||m.isFluid||m.isNg||m.isOxy||!!m.cri;
  if(m.isNg&&!m.manual)throw new Error("The NGT row has no feeding amount or rate.");
  if(type!=="obs"&&type!=="npo"&&!m.route)throw new Error(drug+" has no administration route.");
  if(!special&&m.rate==null&&!m.manual)throw new Error(drug+" has neither a positive dose nor manual dose instructions.");
  return m;
}
function normalizeChartObject(o){
  if(!o||typeof o!=="object"||Array.isArray(o)||o.v!==1||o.app!=="askavet-hospital-chart"||!Array.isArray(o.meds))throw new Error("That file is not an ASK A VET hospital chart.");
  if(o.meds.length>250)throw new Error("That chart contains too many rows.");
  var state={fields:{},segs:{},additives:[],meds:[]};
  FIELD_IDS.forEach(function(id){state.fields[id]=o.fields&&typeof o.fields[id]==="string"?safeString(o.fields[id],10000):defaultField(id);});
  if(o.fields!=null&&(!o.fields||typeof o.fields!=="object"||Array.isArray(o.fields)))throw new Error("The patient field set is invalid.");
  if(o.segs!=null&&(!o.segs||typeof o.segs!=="object"||Array.isArray(o.segs)))throw new Error("The chart selections are invalid.");
  SEG_IDS.forEach(function(id){
    if(o.segs&&own(o.segs,id)){
      var value=o.segs[id];
      if(value===null&&SEG_DEFAULTS[id]===null)state.segs[id]=null;
      else if(typeof value==="string"&&SEG_ALLOWED[id].indexOf(value)!==-1)state.segs[id]=value;
      else throw new Error("The saved chart has an invalid "+id+" selection.");
    }else state.segs[id]=SEG_DEFAULTS[id];
  });
  if(o.additives!=null&&!Array.isArray(o.additives))throw new Error("The additive list is invalid.");
  if(o.additives&&o.additives.length>50)throw new Error("The saved chart contains too many additives.");
  (o.additives||[]).forEach(function(a,index){
    if(!a||typeof a!=="object"||Array.isArray(a))throw new Error("Additive "+(index+1)+" is invalid.");
    state.additives.push({id:index+1,name:safeString(a.name,200),unit:safeString(a.unit,30),custom:!!a.custom,amt:a.amt==null?"":safeString(String(a.amt),80)});
  });
  state.meds=o.meds.map(normalizeMed);
  [["fluid",function(m){return m.isFluid&&!m.orderEnded}], ["oxygen",function(m){return m.isOxy&&!m.orderEnded}], ["NGT",function(m){return m.isNg&&!m.orderEnded}], ["NPO",function(m){return m.type==="npo"}]].forEach(function(pair){
    if(state.meds.filter(pair[1]).length>1)throw new Error("The saved chart contains more than one "+pair[0]+" row.");
  });
  return state;
}
function setFieldSafely(id,value){
  var el=$(id);
  el.value=value;
  if(el.tagName==="SELECT"&&el.value!==value)el.value=defaultField(id);
}
function resetEntryForms(){
  ["mDrug","mRate","mConc","mTab","mManual","cDrug","cRate","cConc","nAmt","nbMeds","nbVol","oxRate","oxFio"].forEach(function(id){$(id).value=""});
  $("mUnit").value="";$("mRoute").value="";$("mFreq").value="";$("mFirst").value="8";$("mStop").value="noend";$("mStop").disabled=true;
  $("mPrn").checked=false;$("prnWrap").classList.remove("on");
  $("cUnit").value="mcgkgmin";$("cFirst").value="0";$("cStop").value="noend";
  $("nMode").value="q4";$("nFirst").value="8";$("nFirst").disabled=false;$("nStop").value="noend";$("nStop").disabled=true;
  $("nbMin").value="10";$("nbFreq").value="q6";$("nbFirst").value="8";
  $("oxUnit").value="lmin";$("oxVia").value="Nasal prongs";$("oxFirst").value="0";$("oxStop").value="noend";
  $("oTask").value=OBS[0].n;$("oCustom").value="";$("oCustomWrap").style.display="none";$("oFreq").value=OBS[0].f;$("oFirst").value="0";
}
function applyChartState(state){
  FIELD_IDS.forEach(function(id){setFieldSafely(id,state.fields[id]);});
  SEG_IDS.forEach(function(id){resetSeg(id,state.segs[id]);});
  curWU=segState.segWU||"kg";
  $("iWeight").placeholder=curWU;
  additives=state.additives;
  addSeq=additives.length;
  meds=state.meds;
  medSeq=meds.length;
  lastWeight=getWeight();
  var legacyNpo=meds.filter(function(m){return m.type==="npo"&&m.npoInstruction==null})[0];
  if(legacyNpo)legacyNpo.npoInstruction=($("iNPO").value||"").trim();
  meds.forEach(backfillGivenSnapshots);
  resetEntryForms();
  var npo=meds.filter(function(m){return m.type==="npo"})[0];
  $("npoStart").value=npo?String(npo.npo.start):"20";
  $("npoEnd").value=npo?(npo.npo.end==null?"noend":String(npo.npo.end)):"noend";
  if(($('iDietText').value||"").trim()&&segState.segDiet!=="Yes")resetSeg("segDiet","Yes");
  $("dietWrap").style.display=segState.segDiet==="Yes"?"block":"none";
  $("customWrap").style.display=segState.segMethod==="custom"?"block":"none";
  $("fTypeWrap").style.display=$("fSel").value==="other"?"block":"none";
  renderAdditives();
  renderAlerts();renderWConv();renderRER();renderHead();renderBody();fluidCalc();renderCriPreview();
}
function loadChartFromJson(json){
  var o;
  var incoming;
  try{o=JSON.parse(json);incoming=normalizeChartObject(o)}
  catch(e){notice("amber","<b>Caution.</b> "+escapeHtml(e&&e.message?e.message:"That file is not a valid chart file."));return false;}
  var previous;
  try{previous=normalizeChartObject(JSON.parse(chartToJson()))}catch(ignore){}
  disarmConfirms();
  try{applyChartState(incoming)}
  catch(e){
    if(previous){try{applyChartState(previous)}catch(ignore2){}}
    notice("red","<b>Could not load the chart.</b> The current patient was kept unchanged.");
    return false;
  }
  notice("ok","<b>Loaded.</b> Chart restored from file. Check the patient details and every dose before use.");
  return true;
}

/* ---------- monitoring / care task presets ---------- */
var OBS=[
  {n:"Temp",f:"q6"},{n:"HR",f:"q6"},{n:"RR",f:"q6"},{n:"Pain score",f:"q6"},
  {n:"Blood glucose",f:"q4"},{n:"Blood pressure",f:"q12"},
  {n:"Feed",f:"q8"},{n:"Water check",f:"q6"},{n:"Walk / toilet",f:"q6"},
  {n:"Urination",f:"q6"},{n:"Faeces",f:"q12"},{n:"Vomiting watch",f:"q6"},
  {n:"IV catheter check",f:"q12"},{n:"Wound / drain check",f:"q12"},{n:"NGT suction",f:"q4"}
];
function addObs(){
  var sel=$("oTask").value;
  var name=sel==="custom"?($("oCustom").value||"").trim():sel;
  if(!name){notice("amber","<b>Caution.</b> Enter a name for the custom task before adding it.");$("oCustom").focus();return;}
  for(var i=0;i<meds.length;i++){
    if(meds[i].type==="obs"&&!meds[i].orderEnded&&meds[i].drug===name){notice("info","<b>Note.</b> "+escapeHtml(name)+" is already on the chart. Click its cells to record values.");return;}
  }
  var freq=$("oFreq").value;
  var first=parseInt($("oFirst").value,10);
  if(!isFinite(first)||first<0||first>23)first=0;
  meds.push({id:++medSeq,type:"obs",drug:name,route:"",rate:null,conc:null,manual:null,freq:freq,first:first,isFluid:false,vals:{},cells:scheduleCells(freq,first)});
  notice("","");
  if(sel==="custom")$("oCustom").value="";
  renderBody();
}

/* ---------- copyable chart summary ---------- */
function givenSummary(m){
  var keys=Object.keys(m.given||{}).map(Number).filter(function(h){return h>=0&&h<24}).sort(function(a,b){return a-b});
  if(!keys.length)return "";
  return keys.map(function(h){
    var detail=m.givenDetails&&m.givenDetails[h]?m.givenDetails[h]:null;
    var time=detail&&detail.time?detail.time:m.given[h];
    var text=pad2(h)+":00 recorded "+time;
    if(detail&&detail.dose)text+=" ["+detail.dose+(detail.weightKg?" at "+fmt(detail.weightKg)+" kg":"")+"]";
    return text;
  }).join(", ");
}
function chartSummaryText(){
  var get=function(id){return ($(id).value||"").trim()};
  var L=[];
  L.push("HOSPITAL PATIENT CHART");
  L.push("Clinic / hospital: "+(get("iClinic")||"-"));
  L.push("Date: "+get("iDate")+(get("iDay")?" (day "+get("iDay")+" of stay)":"")+"  Location: "+(get("iDept")||"-"));
  L.push("Patient: "+(get("iName")||"-")+"  Patient no: "+(get("iPatientNo")||"-")+"  Client no: "+(get("iClient")||"-"));
  var wkg=getWeight();
  L.push("Species: "+((segState.segSpecies||"dog")==="cat"?"Cat":"Dog")+"  Age: "+(get("iAge")||"-")+"  Sex: "+($("iSex").value||"-")+"  Desexed: "+(segState.segDesexed||"-")+"  Weight: "+(wkg?bothWeights(wkg):"-")+"  Dr in charge: "+(get("iDr")||"-"));
  if(wkg)L.push("RER: "+fmt(70*Math.pow(wkg,0.75))+" kcal/day (70 x kg^0.75)");
  L.push("Code status: "+(segState.segCode||"NOT SET")+"  Patient behaviour: "+behaviourDisplay());
  if(get("iReason"))L.push("Reason: "+get("iReason"));
  var flags=[];
  if(segState.segBarrier&&segState.segBarrier!=="None")flags.push("🧤 Barrier nursing: "+segState.segBarrier);
  if(segState.segImm==="Yes")flags.push("🛡️ Immunocompromised");
  if(segState.segInf==="Yes")flags.push("☣️ INFECTIOUS");
  if(segState.segChemo==="Yes")flags.push("🧪 CYTOTOXIC");
  if(segState.segSz==="Yes")flags.push("⚡ Seizure watch");
  L.push("Flags: "+(flags.length?flags.join(", "):"none"));
  if(segState.segDiet==="Yes"||get("iDietText"))L.push("🍽️ Special diet: "+(get("iDietText")||"yes"));
  var npoOrder=meds.filter(function(m){return m.type==="npo"})[0];
  if(npoOrder&&Object.keys(npoOrder.cells||{}).length)L.push("🚫 NPO: "+npoMeta(npoOrder)+(get("iNPO")?" | "+get("iNPO"):""));
  else if(hasNewNpoFreeText(npoOrder))L.push("🚫 NPO: "+get("iNPO"));
  if(get("iNotes"))L.push("Notes: "+get("iNotes"));
  var fr=null;
  meds.forEach(function(m){if(m.isFluid&&!m.orderEnded)fr=m});
  if(fr)L.push("Fluids: "+fr.drug+" IV CRI, "+(fr.continued?"continued from previous day":"from "+pad2(fr.first||0)+":00")+", "+stopPhrase(fr.stop)+", "+(fr.manual||"")+(givenSummary(fr)?" | recorded: "+givenSummary(fr):""));
  var medRows=[],obsRows=[];
  meds.forEach(function(m){
    if(m.isFluid&&!m.orderEnded)return;
    if(m.type==="obs")obsRows.push(m);else medRows.push(m);
  });
  if(medRows.length){
    L.push("");
    L.push("MEDICATIONS / TREATMENTS:");
    medRows.forEach(function(m){
      if(m.type==="npo"){L.push("- 🚫 NPO: "+npoMeta(m));return;}
      var dtxt=snapshotDoseText(m);
      if(m.rate!=null&&((m.unit||"mgkg")==="mgkg"||(m.unit||"mgkg")==="mcgkg"))dtxt+=" ("+fmt(m.rate)+" "+unitLabel(m.unit||"mgkg")+")";
      var schedule;
      if(m.orderEnded)schedule=((m.freq==="cri"||m.ngCri)&&!m.endedAt?"continuous order ended at its scheduled stop":"order discontinued"+(endedWhen(m)?" at "+endedWhen(m):""));
      else if(m.freq==="cri"||m.ngCri)schedule=(m.continued?"continuous, continued from previous day":"continuous from "+pad2(m.first||0)+":00")+", "+stopPhrase(m.stop);
      else{
        var hrs=Object.keys(m.cells||{}).map(Number).filter(function(h){return h>=0&&h<24}).sort(function(a,b){return a-b}).map(function(h){return pad2(h)+":00"}).join(", ");
        schedule=FREQ[m.freq].label+(hrs?" at "+hrs:"");
      }
      var recorded=givenSummary(m);
      L.push("- "+m.drug+" "+m.route+" "+dtxt+", "+schedule+(m.prn&&m.freq!=="prn"?" PRN (give only if needed)":"")+(m.prevGiven?" (given on a previous day)":"")+(recorded?"; recorded "+recorded:""));
    });
  }
  if(obsRows.length){
    L.push("");
    L.push("MONITORING:");
    obsRows.forEach(function(m){
      var ks=Object.keys(m.vals||{}).map(Number).sort(function(a,b){return a-b});
      var vals=ks.map(function(h){return pad2(h)+":00 "+m.vals[h]}).join(", ");
      L.push("- "+m.drug+", "+(m.orderEnded?("task discontinued"+(endedWhen(m)?" at "+endedWhen(m):"")):FREQ[m.freq].label)+(vals?" | recorded: "+vals:"")+(m.history&&m.history.length?" | "+m.history.length+" prior-day record"+(m.history.length>1?"s":"")+" archived in chart file":""));
    });
  }
  L.push("");
  L.push("ASK A VET(TM) Hospital Patient Chart");
  return L.join("\n");
}

/* ---------- print-only patient header on the grid page ---------- */
function buildPrintSummary(){
  var get=function(id){return ($(id).value||"").trim()};
  var summary=$("printSummary");
  summary.innerHTML="";

  var top=document.createElement("div");
  top.className="print-patient-row";
  var patient=document.createElement("span");
  patient.className="print-patient-name";
  patient.textContent="Patient: "+(get("iName")||"NOT ENTERED");
  top.appendChild(patient);
  var behaviour=document.createElement("span");
  behaviour.className="print-behaviour";
  if(segState.segBeh==="Calm")behaviour.classList.add("calm");
  else if(segState.segBeh==="Anxious")behaviour.classList.add("anxious");
  else if(segState.segBeh==="Aggressive")behaviour.classList.add("aggressive");
  behaviour.innerHTML='<span class="inline-emoji" aria-hidden="true">'+(BEHAVIOUR_EMOJIS[segState.segBeh]||"🐾")+'</span><span>Patient behaviour: '+escapeHtml(segState.segBeh||"NOT SET")+'</span>';
  top.appendChild(behaviour);
  summary.appendChild(top);

  var bits=[];
  if(get("iClinic"))bits.push(get("iClinic"));
  if(get("iPatientNo"))bits.push("Pt "+get("iPatientNo"));
  if(get("iClient"))bits.push("Client "+get("iClient"));
  var wkg=getWeight();
  if(wkg)bits.push(fmt(wkg)+" kg / "+fmt(wkg*LB_PER_KG)+" lb");
  bits.push((segState.segSpecies||"dog")==="cat"?"Cat":"Dog");
  if($("iSex").value)bits.push($("iSex").value);
  if(segState.segDesexed)bits.push(segState.segDesexed==="Yes"?"desexed":"entire");
  if(get("iAge"))bits.push(get("iAge"));
  if(get("iDept"))bits.push(get("iDept"));
  if(get("iDr"))bits.push(get("iDr"));
  if(get("iDate"))bits.push(get("iDate")+(get("iDay")?" day "+get("iDay"):""));
  bits.push("Code: "+(segState.segCode||"NOT SET"));
  function line(text){
    if(!text)return;
    var div=document.createElement("span");
    div.className="printline";
    div.textContent=text;
    summary.appendChild(div);
  }
  line(bits.join("  ·  "));
  if(get("iReason"))line("Reason: "+get("iReason"));
  if(segState.segDiet==="Yes"||get("iDietText"))line("🍽️ Diet: "+(get("iDietText")||"special diet"));
  var npoRow=meds.filter(function(m){return m.type==="npo"})[0];
  if(npoRow&&Object.keys(npoRow.cells||{}).length)line("🚫 NPO: "+npoMeta(npoRow)+(get("iNPO")?" · "+get("iNPO"):""));
  else if(hasNewNpoFreeText(npoRow))line("🚫 NPO: "+get("iNPO"));
  if(get("iNotes"))line("Notes: "+get("iNotes"));
  $("printFoot").textContent="Printed from the ASK A VET™ Hospital Patient Chart · askavet.com · Talk. Track. Trust.";
  ["iReason","iDietText","iNPO","iNotes"].forEach(function(id){
    var ta=$(id);
    var mirror=ta.nextElementSibling;
    if(!mirror||!mirror.classList||!mirror.classList.contains("printta")){
      mirror=document.createElement("div");
      mirror.className="printta";
      ta.parentNode.insertBefore(mirror,ta.nextSibling);
    }
    mirror.textContent=ta.value||" ";
  });
}

/* ---------- setup ---------- */
function fillHourSelect(sel,defHour){
  for(var h=0;h<24;h++){
    var o=document.createElement("option");
    o.value=h;o.textContent=pad2(h)+":00";
    if(h===defHour)o.selected=true;
    sel.appendChild(o);
  }
}

initSeg("segCode");
initSeg("segBeh",null,null,true);
initSeg("segBarrier");
initSeg("segImm");
initSeg("segInf");
initSeg("segChemo");
initSeg("segSz");
initSeg("segDiet",null,function(v){
  var hasText=!!($("iDietText").value||"").trim();
  if(v==="No"&&hasText){resetSeg("segDiet","Yes");notice("amber","<b>Caution.</b> Dietary instructions are entered, so Special diet remains set to Yes. Clear the instructions first if no special diet is required.");v="Yes";}
  $("dietWrap").style.display=v==="Yes"?"block":"none";
});
initSeg("segSpecies","dog",function(){fluidCalc();renderRER()});
initSeg("segDesexed",null,renderRER,true);
var curWU="kg";
initSeg("segWU","kg",function(v){
  if(v===curWU)return;
  var raw=parseFloat($("iWeight").value);
  if(isFinite(raw)&&raw>0){
    $("iWeight").value=(v==="lb"?raw*LB_PER_KG:raw/LB_PER_KG).toFixed(2);
  }
  curWU=v;
  $("iWeight").placeholder=v;
  onWeightChange();
});
initSeg("segMethod","formula",function(v){$("customWrap").style.display=v==="custom"?"block":"none";fluidCalc()});

fillHourSelect($("mFirst"),8);
fillHourSelect($("mStop"),-1);
fillHourSelect($("oFirst"),0);
fillHourSelect($("fFirst"),0);
fillHourSelect($("fStop"),-1);
fillHourSelect($("cFirst"),0);
fillHourSelect($("cStop"),-1);
fillHourSelect($("nFirst"),8);
fillHourSelect($("nStop"),-1);
fillHourSelect($("nbFirst"),8);
fillHourSelect($("oxFirst"),0);
fillHourSelect($("oxStop"),-1);
fillHourSelect($("npoStart"),20);
fillHourSelect($("npoEnd"),-1);
OBS.forEach(function(o){
  var opt=document.createElement("option");
  opt.value=o.n;opt.textContent=o.n;
  $("oTask").appendChild(opt);
});
var customOpt=document.createElement("option");
customOpt.value="custom";customOpt.textContent="Custom task...";
$("oTask").appendChild(customOpt);
$("oTask").addEventListener("change",function(){
  var v=this.value;
  $("oCustomWrap").style.display=v==="custom"?"block":"none";
  if(v!=="custom"){
    for(var i=0;i<OBS.length;i++){if(OBS[i].n===v){$("oFreq").value=OBS[i].f;break;}}
  }
});

var today=new Date();
$("iDate").value=today.getFullYear()+"-"+pad2(today.getMonth()+1)+"-"+pad2(today.getDate());

$("addMedBtn").addEventListener("click",addMed);
["mDrug","mRate","mConc","mTab","mManual"].forEach(function(id){
  $(id).addEventListener("keydown",function(e){if(e.key==="Enter"){e.preventDefault();addMed();}});
});
$("mPrn").addEventListener("change",function(){$("prnWrap").classList.toggle("on",this.checked)});
$("mFreq").addEventListener("change",function(){$("mStop").disabled=this.value!=="cri";if(this.value!=="cri")$("mStop").value="noend";});
$("addFluidBtn").addEventListener("click",addFluidRow);
$("addObsBtn").addEventListener("click",addObs);
$("addCriBtn").addEventListener("click",addCri);
$("addNgBtn").addEventListener("click",addNg);
$("nMode").addEventListener("change",function(){$("nStop").disabled=this.value!=="cri";if(this.value!=="cri")$("nStop").value="noend";});
$("addNebBtn").addEventListener("click",addNeb);
$("addOxyBtn").addEventListener("click",addOxy);
$("oxVia").addEventListener("change",function(){
  if(this.value==="High-flow nasal oxygen")$("oxUnit").value="lkgmin";
  else if($("oxUnit").value==="lkgmin")$("oxUnit").value="lmin";
});
$("addNpoBtn").addEventListener("click",addNpo);
["cRate","cConc"].forEach(function(id){$(id).addEventListener("input",renderCriPreview)});
$("cUnit").addEventListener("change",renderCriPreview);
$("cFirst").addEventListener("change",renderCriPreview);
$("cStop").addEventListener("change",renderCriPreview);
["iDietKcal"].forEach(function(id){$(id).addEventListener("input",renderRER)});
$("iDietUnit").addEventListener("change",renderRER);
$("iMeals").addEventListener("change",renderRER);
$("saveBtn").addEventListener("click",saveChart);
$("loadBtn").addEventListener("click",function(){$("loadFile").click()});
function chartHasUnsavedContent(){
  if(meds.length||additives.length)return true;
  if(FIELD_IDS.some(function(id){return String($(id).value||"")!==String(defaultField(id));}))return true;
  return SEG_IDS.some(function(id){return (segState[id]||null)!==(SEG_DEFAULTS[id]||null);});
}
$("loadFile").addEventListener("change",function(){
  var f=this.files&&this.files[0];
  if(!f)return;
  var inp=this;
  var r=new FileReader();
  r.onload=function(){
    if(chartHasUnsavedContent()&&!window.confirm("Replace the current patient chart with the selected saved chart? Save or print the current chart first if it belongs in the clinical record.")){inp.value="";return;}
    loadChartFromJson(String(r.result));inp.value="";
  };
  r.onerror=function(){notice("amber","<b>Caution.</b> The selected chart file could not be read.");inp.value="";};
  r.readAsText(f);
});
var nextArmed=null;
$("nextDayBtn").addEventListener("click",function(e){
  if(e.detail>1)return;
  var b=$("nextDayBtn");
  if(nextArmed){
    if(!window.confirm("Start the next day now? The current day will be archived inside the chart file, but you should also save or print it for the patient record."))return;
    clearTimeout(nextArmed);nextArmed=null;b.textContent="Start next day";startNextDay();return;
  }
  b.textContent="Clears ticks and values. Click again";
  nextArmed=setTimeout(function(){nextArmed=null;b.textContent="Start next day"},4000);
});
$("fSel").addEventListener("change",function(){
  $("fTypeWrap").style.display=this.value==="other"?"block":"none";
  fluidCalc();
});
$("addSel").addEventListener("change",function(){
  if(this.value)addAdditive(this.value);
  this.value="";
});
["iName","iPatientNo","iWeight","iNPO"].forEach(function(id){$(id).addEventListener("input",function(){notice("","")})});
$("iWeight").addEventListener("input",onWeightChange);
$("iNPO").addEventListener("input",renderAlerts);
$("iDietText").addEventListener("input",function(){
  notice("","");
  if((this.value||"").trim()&&segState.segDiet!=="Yes"){resetSeg("segDiet","Yes");$("dietWrap").style.display="block";}
  renderAlerts();
});
["fCustom","fDehy","fHours","fLoss","fType"].forEach(function(id){$(id).addEventListener("input",fluidCalc)});
$("fFirst").addEventListener("change",fluidCalc);
$("fStop").addEventListener("change",fluidCalc);
function canFinalizeChart(action){
  var enteredWeight=String($("iWeight").value||"").trim();
  if(enteredWeight&&!getWeight()){
    notice("red","<b>Cannot "+action+".</b> Body weight must be a positive number, or the field must be left blank when no weight-dependent order is active.");
    $("iWeight").focus();
    return false;
  }
  if(segState.segInf==="Yes"&&(segState.segBarrier==="None"||!segState.segBarrier)){
    notice("red","<b>Cannot "+action+".</b> This patient is marked infectious. Select Gloves or Full PPE under Barrier nursing before finalising the chart.");
    return false;
  }
  if(meds.length&&(!String($("iName").value||"").trim()||!String($("iPatientNo").value||"").trim())){
    notice("red","<b>Cannot "+action+".</b> Enter both the patient name and patient number so the treatment chart cannot be separated from its identity.");
    return false;
  }
  if(meds.length&&segState.segCode!=="CPR"&&segState.segCode!=="DNR"){
    notice("red","<b>Cannot "+action+".</b> Select CPR or DNR before finalising an active treatment chart.");
    return false;
  }
  var unsafeOnce=meds.filter(function(m){
    if(m.orderEnded||m.freq!=="once"||m.type==="npo")return false;
    var givenCount=Object.keys(m.given||{}).length;
    var onceKeys={};
    Object.keys(m.cells||{}).forEach(function(h){if(m.cells[h]===1||m.cells[h]===2)onceKeys[h]=true;});
    Object.keys(m.vals||{}).forEach(function(h){onceKeys[h]=true;});
    var actionableCount=Object.keys(onceKeys).length;
    return givenCount>1||Object.keys(m.vals||{}).length>1||actionableCount>1||(m.prevGiven&&actionableCount);
  })[0];
  if(unsafeOnce){
    notice("red","<b>Cannot "+action+".</b> "+escapeHtml(unsafeOnce.drug)+" has contradictory once-only dose markings. Correct or discontinue that order first.");
    return false;
  }
  var activeOrders=meds.filter(function(m){return m.type!=="obs"&&m.type!=="npo"&&!m.orderEnded&&(m.freq==="prn"||Object.keys(m.cells||{}).some(function(h){return m.cells[h]===1;}));});
  if(!getWeight()&&activeOrders.some(orderNeedsWeight)){
    notice("red","<b>Cannot "+action+".</b> An active weight-based medication, CRI or oxygen order cannot be calculated. Restore a valid body weight or end the order first.");
    return false;
  }
  var tabletReview=activeOrders.filter(hasUnresolvedTablet)[0];
  if(tabletReview){
    notice("red","<b>Cannot "+action+".</b> "+escapeHtml(tabletReview.drug)+" has an unresolved tablet fraction. Change the tablet strength or formulation, or clear the tablet field after charting an explicit alternative.");
    return false;
  }
  var incomplete=activeOrders.filter(function(m){return !m.isFluid&&!m.isNg&&!m.isOxy&&!m.cri&&m.rate==null&&!m.manual;})[0];
  if(incomplete){
    notice("red","<b>Cannot "+action+".</b> "+escapeHtml(incomplete.drug)+" has no actionable dose or manual instructions.");
    return false;
  }
  if(checkFluidSync()){
    notice("red","<b>Cannot "+action+".</b> The charted fluid order is stale or no longer verifiable. Correct the calculator inputs and add the fluid plan to the chart again.");
    return false;
  }
  var fr=meds.filter(function(m){return m.isFluid&&!m.orderEnded})[0];
  if(fr){
    var f=fluidNumbers(),av=additiveValidation();
    if(!f||(f.errors&&f.errors.length)||av.errors.length||(av.kTotal>0&&f.totalHr*av.kTotal/1000/f.w>0.5)){
      notice("red","<b>Cannot "+action+".</b> Resolve the critical fluid or potassium warning first.");
      return false;
    }
  }
  return true;
}
var printMarker=null;
function preparePrint(){
  /* Ctrl/Cmd+P bypasses the print buttons. It cannot be cancelled reliably, so put any
     finalisation failure directly on the printed sheet as a critical warning. */
  if(!canFinalizeChart("print")){
    var blocked=($("doseNotice").textContent||"This chart contains an unresolved safety issue.").trim();
    $("fluidStale").innerHTML+='<div class="warn red notice"><b>DO NOT USE THIS PRINTED CHART.</b> '+escapeHtml(blocked)+'</div>';
  }
  buildPrintSummary();
  if(appRoot.parentNode!==document.body&&!printMarker){
    printMarker=document.createComment("aav-hospital-chart-print-position");
    appRoot.parentNode.insertBefore(printMarker,appRoot);
    document.body.appendChild(appRoot);
  }
  document.body.classList.add("aav-hospital-chart-printing");
}
function finishPrint(){
  document.body.classList.remove("aav-hospital-chart-printing");
  if(printMarker&&printMarker.parentNode){
    printMarker.parentNode.insertBefore(appRoot,printMarker);
    printMarker.parentNode.removeChild(printMarker);
  }
  printMarker=null;
  checkFluidSync();
}
function requestPrint(){
  if(!canFinalizeChart("print"))return;
  preparePrint();
  window.print();
  setTimeout(finishPrint,0);
}
$("printBtn").addEventListener("click",requestPrint);
$("printBtn2").addEventListener("click",requestPrint);
window.addEventListener("beforeprint",preparePrint);
window.addEventListener("afterprint",finishPrint);
$("copyBtn").addEventListener("click",function(){
  if(!canFinalizeChart("copy the chart"))return;
  var txt=chartSummaryText();
  function ok(){notice("ok","<b>Copied.</b> The chart summary is on the clipboard, ready to paste into your practice management software.")}
  function fallback(){
    var ta=document.createElement("textarea");ta.value=txt;ta.style.position="fixed";ta.style.opacity="0";
    document.body.appendChild(ta);ta.select();
    var done=false;
    try{done=document.execCommand("copy");}catch(e){}
    document.body.removeChild(ta);
    if(done)ok();else notice("amber","<b>Caution.</b> Could not access the clipboard in this environment. Use Print instead, or select the chart and copy manually.");
  }
  if(navigator.clipboard&&navigator.clipboard.writeText)navigator.clipboard.writeText(txt).then(ok,fallback);
  else fallback();
});

function resetSeg(id,val){
  var wrap=$(id);
  Array.prototype.forEach.call(wrap.querySelectorAll("button"),function(b){
    b.setAttribute("aria-pressed",b.getAttribute("data-val")===val?"true":"false");
  });
  segState[id]=val||null;
}
function resetAll(){
  disarmConfirms();
  meds=[];medSeq=0;lastWeight=null;
  ["iClient","iPatientNo","iName","iAge","iWeight","iDr","iDept","iDay","iClinic","iDietKcal","iReason","iDietText","iNPO","iNotes","mDrug","mRate","mConc","mTab","mManual","cDrug","cRate","cConc","nAmt","nbMeds","nbVol","oxRate","oxFio"].forEach(function(id){$(id).value=""});
  $("mUnit").value="";$("cUnit").value="mcgkgmin";$("iDietUnit").value="100g";$("iMeals").value="4";
  $("nMode").value="q4";$("nFirst").value="8";$("nFirst").disabled=false;$("nStop").value="noend";$("nStop").disabled=true;$("npoStart").value="20";$("npoEnd").value="noend";
  $("fFirst").value="0";$("fStop").value="noend";$("cFirst").value="0";$("cStop").value="noend";$("oxFirst").value="0";$("oxStop").value="noend";
  $("nbMin").value="10";$("nbFreq").value="q6";$("nbFirst").value="8";$("oxUnit").value="lmin";$("oxVia").value="Nasal prongs";
  $("mPrn").checked=false;$("prnWrap").classList.remove("on");
  $("iSex").value="";
  var t=new Date();
  $("iDate").value=t.getFullYear()+"-"+pad2(t.getMonth()+1)+"-"+pad2(t.getDate());
  resetSeg("segCode",null);resetSeg("segBeh",null);resetSeg("segBarrier",null);
  resetSeg("segDesexed",null);resetSeg("segWU","kg");curWU="kg";$("iWeight").placeholder="kg";
  resetSeg("segImm",null);resetSeg("segInf",null);resetSeg("segChemo",null);
  resetSeg("segSz",null);resetSeg("segDiet",null);
  resetSeg("segSpecies","dog");resetSeg("segMethod","formula");
  $("dietWrap").style.display="none";$("customWrap").style.display="none";
  $("fSel").value="Hartmann's (LRS)";$("fTypeWrap").style.display="none";$("fType").value="";
  additives=[];renderAdditives();
  $("fCustom").value="50";$("fDehy").value="0";$("fHours").value="24";$("fLoss").value="0";
  $("mRoute").value="";$("mFreq").value="";$("mFirst").value="8";$("mStop").value="noend";$("mStop").disabled=true;
  $("oTask").value=OBS[0].n;$("oCustomWrap").style.display="none";$("oCustom").value="";$("oFreq").value="q6";$("oFirst").value="0";
  notice("","");$("fluidStale").innerHTML="";$("criPreview").innerHTML="";
  renderAlerts();renderWConv();renderRER();renderHead();renderBody();fluidCalc();
}
function disarmConfirms(){
  if(clearArmed){clearTimeout(clearArmed);clearArmed=null;$("clearBtn").textContent="Clear whole chart";}
  if(nextArmed){clearTimeout(nextArmed);nextArmed=null;$("nextDayBtn").textContent="Start next day";}
}
var clearArmed=null;
$("clearBtn").addEventListener("click",function(e){
  if(e.detail>1)return;
  var b=$("clearBtn");
  if(clearArmed){
    if(!window.confirm("Permanently clear this entire chart? Save or print it first if it belongs in the patient record."))return;
    clearTimeout(clearArmed);clearArmed=null;b.textContent="Clear whole chart";resetAll();return;
  }
  b.textContent="Really clear everything? Click again";
  clearArmed=setTimeout(function(){clearArmed=null;b.textContent="Clear whole chart"},4000);
});

renderAlerts();
renderWConv();
renderRER();
renderHead();
renderBody();
fluidCalc();
/* keep the current-hour marker fresh on long-open screens */
setInterval(renderHead,60000);

/* integrity check: the static SEO reference table must match the live formulas,
   so the crawlable content can never silently drift from what the tool computes */
(function(){
  var tbl=$("rerTable");
  if(!tbl)return;
  var rows=tbl.querySelectorAll("tbody tr[data-w]");
  var bad=0;
  Array.prototype.forEach.call(rows,function(r){
    var w=parseFloat(r.getAttribute("data-w"));
    var cells=r.querySelectorAll("td");
    var expect=[fmt(70*Math.pow(w,0.75)),fmt(132*Math.pow(w,0.75)/24),fmt(80*Math.pow(w,0.75)/24)];
    var got=[cells[2].textContent.trim(),cells[3].textContent.trim(),cells[4].textContent.trim()];
    for(var i=0;i<3;i++)if(expect[i]!==got[i])bad++;
  });
  if(bad>0){
    console.error("RER reference table integrity check failed: "+bad+" cell(s) drifted from the live formula");
    var warn=document.createElement("p");
    warn.className="rworking";warn.style.color="var(--red)";
    warn.textContent="Note: this reference table is being verified.";
    tbl.parentNode.insertBefore(warn,tbl);
  }
})();

    }
  }
  if (!customElements.get('s-hospital-patient-chart')) {
    customElements.define('s-hospital-patient-chart', HospitalPatientChart);
  }
})();
